// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*:not('.space-editor') {
  margin: 0;
  padding: 0;
}

* {
  box-sizing: border-box;
}

:root {
  --sidebar-full-width: 300px;

  /* --sidemenu-background-color: rgb(247, 247, 245);
    --hover-background-color: #019299ab;
    --primary-color: rgb(124, 58, 237); */

  /* Reworked Palette */
  --primary-font-color: #333333; /* Softer than pure black */
  --secondary-font-color: #444444; /* For secondary text */
  --tertiary-font-color: #efefef;
  --primary-icon-color: #333333; /* Softer black for icons */
  --primary-header-title-color: #e3e8ed;
  --editor-heading-font-color: #ffffff;
  --editor-text-font-color: '#333333';

  --editor-border-color: rgba(5, 5, 5, 0.06);
  --collapse-button-color: rgb(240, 240, 240);
  /* --collpsae-button-font-color :  */
  /* Primary Accent Color */
  --primary-color: #1890ff; /* Vibrant Purple */
  --primary-color-hover: #6d28d9; /* Darker purple for hover or active elements */
  --primary-color-light: #c4b5fd; /* Light Purple for background accents */

  /* Side Navigation Background */
  --sidemenu-background-color: #f1f5f9; /* Clean, slightly cool light gray */
  --sidemenu-background-color-hover: rgba(51, 51, 51, 0.06);
  /* Accent or Success Colors */
  --highlight-color: #38bdf8; /* For focus/input highlights */
  --success-color: #34d399; /* Bright green for success icons and messages */
  --danger-color: #f87171; /* Soft red for warnings/errors */

  /* Text Area Background (outside editor for reference) */
  --box-background-color: #fafafa; /* Light background for reading areas */
  --emoji-hover-color: #eee;
  --sp-color-black: #000000;
  --sp-color-white: #ffffff;
  --editor-font-family: 'Inter', sans-serif;

  /* new css variable */
  /* new themes */
  --remirror-editor-width: 760px;
}

::-webkit-scrollbar {
  height: 1px;
  width: 5px;
  background: #d0d0d0;
}

::-webkit-scrollbar-thumb {
  background: #8d8d8d; /* White thumb color */
  border-radius: 10px; /* Rounded corners for the thumb */
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25); /* Shadow effect */
}

::-webkit-scrollbar-corner {
  background: #8d8d8d; /* Match thumb color for corner */
}

body,
html {
  margin: 0;
  padding: 0;
}

html,
body,
#root {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  max-height: 100vh;
  overflow-x: hidden;
  overflow-y: hidden;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;
}

body {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: var(--editor-heading-font-color);
  cursor: default;
  background-color: var(--cms-color-bg-container);
}

.home-layout,
.settings-layout {
  display: flex;
  height: 100%;
  max-height: 100vh;
  overflow: hidden !important;
}

.organization-name {
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  font-weight: 500;
  cursor: pointer;
}

.sidemenu-wrapper-collapsed {
  background: var(--sidemenu-background-color);
}

.notification-icon {
  font-size: 1rem;
  cursor: pointer;
  border-radius: 5px;
  padding: 2px 8px;
  margin-left: 4px;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
}

.collapse-button-wrapper {
  font-size: 0.9rem;
}

/* .button {
    font-size: 1rem;
    padding: 5px 10px;
    cursor: pointer;
    border: none;
    border-radius: 5px;
  }
   */

.side-menu-search-icon {
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 5px;
  height: 40px;
  border-radius: 8px;
  margin: 0 5px;
}

.plus-icon {
  padding: 2px 8px;
  cursor: pointer;
  border-radius: 5px;
}

.plus-icon:hover {
  background-color: #0d494cab;
}

.document-icon {
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 5px;
  height: 40px;
  border-radius: 8px;
  margin: 0 5px;
}

.document-icon:hover {
  background-color: #0d494cab;
}

.sidebar-menu-item-wrapper {
  background: transparent;
}

.title-input::placeholder {
  width: fit-content;
  font-size: 20px;
  color: #8899a8;
}

.space-body {
  display: flex;
  flex-direction: row;
  height: 100%;
  min-width: 100%;
  position: relative;
}

.space-body .flex-1 {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}

.layout-component {
  width: 83%;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .space-sidebar-menu-wrapper {
    display: none !important;
  }
  .space-header {
    display: none !important;
  }
  .settings-sider {
    overflow-x: hidden;
    display: none !important;
  }
  .flex-row {
    display: block !important;
  }
  .swagger-ui .opblock-tag {
    display: block;
  }
  .space-editor {
    max-height: calc(100vh - 116px) !important;
  }
}
.space-editor {
  position: relative;
  flex: 1;
  max-height: calc(100vh - 116px);
  width: 100% !important;
  overflow-x: hidden;
  overflow-y: auto;
}

.space-sidebar-menu-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: var(--sidebar-full-width);
  max-width: var(--sidebar-full-width);
  flex: 1;
  border-right: 2px solid var(--editor-border-color);
  overflow-x: auto;
  overflow-y: hidden;
  transition: all 0.3s ease;
  opacity: 1;
  /* will-change: width; */
}

.option-button {
  min-width: 24px !important;
  max-width: 24px !important;
  min-height: 24px !important;
  max-height: 24px !important;
  display: none !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}
.watching-icon {
  color: #0052cc;
}

.menu-list-folder-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px 10px 2px;
}

.custom-submenu .ant-menu-submenu-arrow {
  display: none !important;
}

.ant-popover-inner {
  background-color: var(--editor-heading-font-color);
}
.ant-dropdown .flex-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-centered {
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-antmenu {
  overflow: auto !important;
}

/* .user-space-plus-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 7px 0;
  border-radius: 8px;
  font-size: 15px;
  margin-right: 5px;
  background-color: rgba(0, 0, 0, 0.05);
  gap: 10px;
} */

.user-space-plus-icon-wrapper:hover {
  background-color: rgba(0, 0, 0, 0.15);
}

/* styles for google sign in widget */

.gsi-material-button {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-appearance: none;
  user-select: none;
  appearance: none;
  background-color: WHITE;
  background-image: none;
  border: 1px solid #747775;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #1f1f1f;
  cursor: pointer;
  font-family: 'Inter', sans-serif !important;
  font-size: 14px;
  height: 40px;
  letter-spacing: 0.25px;
  outline: none;
  overflow: hidden;
  padding: 6px 12px !important;
  position: relative;
  text-align: center;
  -webkit-transition:
    background-color 0.218s,
    border-color 0.218s,
    box-shadow 0.218s;
  transition:
    background-color 0.218s,
    border-color 0.218s,
    box-shadow 0.218s;
  vertical-align: middle;
  white-space: nowrap;
  width: auto;
  max-width: 400px;
  min-width: min-content;
}

.gsi-material-button .gsi-material-button-icon {
  height: 20px;
  margin-right: 12px;
  min-width: 20px;
  width: 20px;
}

.gsi-material-button .gsi-material-button-content-wrapper {
  -webkit-align-items: center;
  align-items: center;
  display: flex;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  height: 100%;
  justify-content: center !important;
  position: relative;
  width: 100%;
}

.gsi-material-button .gsi-material-button-state {
  -webkit-transition: opacity 0.218s;
  transition: opacity 0.218s;
  bottom: 0;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.gsi-material-button:disabled {
  cursor: default;
  background-color: #ffffff61;
  border-color: #1f1f1f1f;
}

.gsi-material-button:disabled .gsi-material-button-contents {
  opacity: 38%;
}

.gsi-material-button:disabled .gsi-material-button-icon {
  opacity: 38%;
}

.gsi-material-button:not(:disabled):active .gsi-material-button-state,
.gsi-material-button:not(:disabled):focus .gsi-material-button-state {
  background-color: #303030;
  opacity: 12%;
}

.gsi-material-button:not(:disabled):hover {
  -webkit-box-shadow:
    0 1px 2px 0 rgba(60, 64, 67, 0.3),
    0 1px 3px 1px rgba(60, 64, 67, 0.15);
  box-shadow:
    0 1px 2px 0 rgba(60, 64, 67, 0.3),
    0 1px 3px 1px rgba(60, 64, 67, 0.15);
}

.gsi-material-button:not(:disabled):hover .gsi-material-button-state {
  background-color: #303030;
  opacity: 8%;
}

/* login page styles */

.login-container {
  align-items: center;
  background-color: #fff;
  border-radius: 0.75rem;
  display: flex;
  justify-content: center;
  left: 50%;
  overflow: hidden;
  padding: 6rem 1rem 4rem;
  position: absolute;
  text-align: center;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: min(100%, 1140px);
}

.svg-container {
  transform: translate(-110px, 10px);
}

.image-container {
  display: flex;
  align-items: center;
  width: 50%;
}

.login-container h1 {
  text-align: center;
  margin-bottom: 2px;
}

.login-container h2 {
  text-align: center;
  margin-bottom: 2px;
}

.login-container h3 {
  text-align: center;
  margin-bottom: 30px;
}

.login-container label {
  margin-bottom: 8px;
}

@media (max-width: 767px) {
  .login-container {
    align-items: center;
    background-color: #fff;
    border-radius: 0.75rem;
    display: flex;
    justify-content: center;
    left: 50%;
    overflow: hidden;
    padding: 6rem 1rem 4rem;
    position: absolute;
    text-align: center;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 80%;
  }
  .image-container {
    display: none;
  }
  .login-logos {
    flex-direction: column;
  }
  .file-setting-button {
    display: none;
  }
  .menu-back-button {
    display: block !important;
  }
}
.menu-back-button {
  display: none;
}
/* Admin layout styles */

.admin-layout-header {
  background-color: var(--sidemenu-background-color);
}

/* organization page styles */

.orgnization-component-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  min-height: 100vh;
}
.back-button {
  display: none;
}
.organization-second-wrappper {
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 20px;
  min-width: 50%;
}

.organization-title {
  text-align: center;
  padding: 20px 0px;
  font-weight: 500;
  font-size: 25px;
}

.organization-form-wrapper {
  margin: 30px 0px;
}

.radio-container {
  text-align: center;
}

/* integrations page styles */

.integration-page-wrapper {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  padding: 20px 40px;
}

.integration-title {
  margin: 3rem 0px;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}

.card-wrapper {
  min-height: 16vh;
  width: 17%;
  transition: transform 0.3s ease;
  box-shadow:
    0px 1px 2px 0px rgba(0, 0, 0, 0.15),
    0px -1px 1px 0px rgba(0, 0, 0, 0.05);
  cursor: pointer;
}

.card-wrapper .card-inner-wrapper {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.card-wrapper .card-inner-wrapper .auth-success-chip {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  background-color: rgba(0, 255, 0, 0.2);

  padding: 4px 12px;
  border-radius: 8px;
  cursor: default;
  align-self: flex-start;
  justify-self: flex-end;
}

.card-wrapper:hover {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.integration-cards-container {
  display: flex;
  justify-content: flex-start;
  gap: 4rem;
}

.org-list-wrapper {
  min-height: 100vh;
}

.org-form-wrapper {
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
  width: 30%;
  min-height: 200px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.org-title {
  font-size: 20px;
  font-weight: 600;
}

.org-select-wrapper {
  margin: 30px auto;
  width: 100%;
}

.bitbucket_form_wrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.bitbucket_workspace_form_wrapper {
  padding: 2rem;
  width: 100%;
  min-width: 300px;
  max-width: 600px;
  box-shadow:
    rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
}

.bitbucket_workspace_form_wrapper > .bitbucket_workspace_form {
  width: 100%;
}

.bitbucket_form_control .field_label {
  display: block;
  font-size: 1rem;
  font-weight: 600;
  padding: 0 0 0.25rem;
}

.user-email-userspace > span:first-child {
  display: inline-block;
  font-size: 15px;
  line-height: 15px;
  font-weight: 500;
}

.space-sidebar-menu-wrapper .ant-tree-treenode:hover .option-button,
.documentation-tab-wrapper + .ant-menu .ant-menu-item:hover .option-button {
  display: block;
}

.generic.modal-body .modal-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px !important;
  gap: 1rem;
  margin-right: 2rem;
  /* padding-bottom: 1rem; */
}

.generic.modal-body .modal-content {
  padding-top: 0.25rem;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
}

.generic.modal-body .preview.modal-header {
  margin: 0px !important;
}

.preview.generic .modal-header-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px 16px 24px;
}

.preview.generic .modal-header-wrapper .modal-header-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.preview.generic .remirror-editor-wrapper {
  margin-left: 0;
  padding: 0;
}

.move-file-input {
  border: 0.5px var(--primary-color);
}

.workspace.one-doc-skeleton {
  margin: 16px 5px;
}

.w-full {
  width: 100%;
}

.h-full {
  height: 100%;
}

.items-center {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.ant-tree-list .ant-tree-node-content-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  padding-inline: unset !important;
}

.flex-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.ant-tree-list .ant-tree-title {
  width: 100%;
  padding: 4px 0;
}

.ant-tree-list .ant-tree-treenode .ant-tree-draggable-icon {
  display: none;
}

.space-breadcrumb {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.access-role-page#access-role-page {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.access-form-wrapper {
  width: 100%;
  max-width: 550px;
}

.access-role-form .form-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
}

:where(.json-editor-wrapper.overflow-hidden) {
  height: calc(100vh - 110px);
  overflow-y: hidden;
}

:where(.overflow-auto) {
  height: 100%;
  overflow-y: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

:where(.json-editor-wrapper > .overflow-auto)::-webkit-scrollbar {
  display: none;
}

:where(.settings-sidebar) {
  max-width: 300px;
  width: 100%;
}

.settings-layout {
  user-select: none;
  cursor: default;
}

.settings-layout .organization-wrapper {
  margin-bottom: 1rem;
}

.settings-layout .organization-name {
  font-size: 1.5rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  font-weight: 600;
  cursor: pointer;
}

.sidebar-menus .sidebar-menus-title {
  font-size: 1rem;
  font-weight: 500;
  padding: 8px;
  cursor: default;
}

:where(.css-dev-only-do-not-override-m4timi).ant-menu-light.ant-menu-root.ant-menu-vertical {
  border: none;
  border-inline-end: none;
  background-color: transparent;
}
.user-dialog-wrapper {
  margin-left: auto;
}

.sub-setting-page {
  padding: 1rem 2rem;
  width: 100%;
  height: 100%;
}

.sub-setting-page .sub-setting-header {
  text-transform: capitalize;
  font-size: 1rem;
  font-weight: 500;
  padding: 0.5rem 2rem;
  background-color: #eee;
}

.sub-setting-page .sub-setting-content-wrapper {
  border: 1px solid #eee;
  padding: 1rem 2rem;
  box-shadow:
    0 4px 6px -1px rgb(0 0 0 / 0.1),
    0 2px 4px -2px rgb(0 0 0 / 0.1);
  margin-bottom: 1rem;
}

.sub-setting-content-wrapper .sub-setting-subtitle {
  padding: 0.125rem 0.5rem;
  background-color: #f1f1f1;
  margin-bottom: 0.5rem;
}

:where(.css-dev-only-do-not-override-m4timi).ant-menu {
  font-size: 16px !important;
}

.sub-setting-subcontent {
  width: 100%;
  margin-top: 1rem;
  padding: 0 2rem;
}

:where(.sub-setting-subcontent).flex-center {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.organization-name {
  color: #fff;
}

.menu-items-spinner-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  padding-top: 2rem;
}

/* span.ant-tree-node-content-wrapper.ant-tree-node-content-wrapper-normal.ant-tree-node-selected span svg {
  fill: #fff !important;
} */

.user-space-plus-icon-wrapper {
  background: var(--primary-color);
  color: #fff !important;
}
*/ .user-space-plus-icon-wrapper {
  background: var(--primary-color);
  color: #fff !important;
  margin: 10px;
}
*/ .button:hover span {
  color: #fff !important;
}

.sidebar-menu-items {
  overflow-y: auto !important;
}

.space-header .space-title input.title-input {
  min-width: 100%;
  border: none;
  line-height: 32px;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  margin: 5px 0;
  background-color: var(--primary-header-title-color);
  font-size: 20px !important;
}

.space-header .space-title input::placeholder {
  color: #fff !important;
  font-family: 'Inter', sans-serif;
  font-size: 20px !important;
  font-weight: 500;
}
.delete-icon.anticon svg {
  fill: #ff0000 !important;
}

.generic.modal-body .modal-header {
  flex-direction: row;
  justify-content: start !important;
}

form#adam-upload-form {
  margin-top: 24px;
}

form#adam-upload-form div label {
  font-size: 16px;
  font-weight: 500;
  color: var(--primary-color) !important;
}

.sidebar-menus .sidebar-menus-title div {
  color: #fff !important;
}

.settings-layout .organization-name {
  display: flex;
  justify-content: center;
  align-items: center;
}

.settings-layout .organization-name div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.span-12 {
  width: 120px !important;
}

.sub-setting-content-wrapper .sub-setting-subtitle {
  background: var(--primary-color) !important;
  color: #fff !important;
}

.sub-setting-page .sub-setting-header {
  background: var(--primary-color) !important;
  color: #fff;
}

.sub-setting-content-wrapper .sub-setting-subtitle {
  background: var(--primary-color) !important;
  color: #fff !important;
}

.bitbucket-page {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  min-height: 100%;
  margin: 0;
  padding: 16px;
  padding-top: 96px;
  position: relative;
  height: 100vh;
  width: 100%;
}

.bitbucket-page::before {
  background: linear-gradient(0deg, rgba(255, 180, 0, 0.5) 0, rgba(255, 180, 0, 0) 100%);
  content: '';
  height: 100vh;
  left: 50%;
  position: fixed;
  transform: translateX(-50%) translateY(50%);
  width: 100%;
  z-index: -1;
}

.card-third-party {
  max-width: 450px;
  width: 100%;
  background: #ffffff;
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.04),
    0 4px 16px -4px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  padding: 32px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

h1.card-title-third-party {
  font-size: 23px;
  text-transform: capitalize;
  text-align: center;
  font-weight: 600;
}

.card-content-third-party p {
  font-size: 14px;
  color: #000;
}

.card-content-third-party p:nth-child(2) {
  font-size: 12px;
}

.card-content-third-party a {
  text-decoration: none;
  font-weight: 400;
  font-size: 12px;
}

.count-down-wrapper {
  background-color: rgba(255, 180, 0, 0.5);
  height: 30px;
  width: 30px;
  border-radius: 25px;
  transition-duration: 4s;
  transition-property: background-color;
  animation-name: grow;
  animation-duration: 9s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  -webkit-transition-property: -webkit-transform background-color;
  -webkit-transition-duration: 4s;
  -moz-transition-property: -moz-transform background-color;
  -moz-transition-duration: 4s;
  -webkit-animation-name: grow;
  -webkit-animation-duration: 9s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  -moz-animation-name: grow;
  -moz-animation-duration: 9s;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: linear;
}

@keyframes grow {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
    background-color: red;
  }
  100% {
    transform: scale(1);
  }
}

p.count-down-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

span.count-down,
p.count-down {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.card-content-third-party {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

:where(.css-dev-only-do-not-override-m4timi).upload-modal.small {
  width: unset !important;
  min-width: 520px !important;
  max-width: 520px !important;
}

:where(.css-dev-only-do-not-override-m4timi).upload-modal.large {
  width: unset !important;
  min-width: 520px !important;
  max-width: 900px !important;
}

.para-link {
  text-align: center;
  width: 83%;
}

.integration-page-wrapper {
  max-width: calc(980px + 8rem) !important;
  margin: 0 auto;
  padding-left: 6rem;
  padding-right: 6rem;
}

.integration-title {
  text-align: left;
  margin: 0;
}
.integration-img-wrapper {
  width: 50%;
}
.int-img {
  width: -moz-available;
  border-radius: 10px !important;
}
.integration-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4rem;
}

*:not('.space-editor') {
  margin: 0;
  padding: 0;
}

* {
  box-sizing: border-box;
}

/* :root {
    --sidemenu-background-color: var(--primary-color);
    --hover-background-color: #019299ab;
  } */

::-webkit-scrollbar {
  height: 1px;
  width: 5px;
  background: #d0d0d0;
}

::-webkit-scrollbar-thumb {
  background: #8d8d8d; /* White thumb color */
  border-radius: 10px; /* Rounded corners for the thumb */
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25); /* Shadow effect */
}

::-webkit-scrollbar-corner {
  background: #8d8d8d; /* Match thumb color for corner */
}

body,
html {
  margin: 0;
  padding: 0;
}

html,
body,
#root {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

body {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
}

.organization-name {
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  font-weight: 500;
  cursor: pointer;
}

.organization-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 10px 10px 0 !important;
}

.organization-wrapper-collapsed {
  padding: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 0;
}

.sidemenu-wrapper {
  min-width: 270px;
  max-width: 270px;
  width: 17%;
  padding: 0 10px;
  background: var(--sidemenu-background-color);
  border-right: 1px solid rgb(227, 232, 237);
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
@media (max-width: 768px) {
  /* Adjust this breakpoint as necessary */
  .sidemenu-wrapper {
    display: none; /* Hide on mobile */
  }
  .sidemenu-wrapper-collapsed {
    display: none;
  }
  .space-breadcumb {
    display: none;
  }
}

.sidemenu-wrapper-collapsed {
  background-color: var(--sidemenu-background-color);
}

.notification-icon {
  font-size: 1rem;
  cursor: pointer;
  border-radius: 5px;
  padding: 2px 8px;
}

.notification-icon:hover {
  background-color: var(--sidemenu-background-color-hover);
  color: var(--primary-color);
}

.bell-icon:hover {
  color: var(--primary-color) !important;
}
.icon-wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
}

.collapse-button-wrapper {
  font-size: 0.9rem;
}

.button {
  font-size: 1rem;
  padding: 5px 10px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  background-color: var(--sidemenu-background-color);
  color: var(--editor-heading-font-color);
}

.side-menu-search-icon {
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 5px;
  height: 40px;
  border-radius: 8px;
  margin: 0 5px;
}

.documentation-tab-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.5rem;
  font-size: 16px;
}

.plus-icon {
  padding: 2px 8px;
  cursor: pointer;
  border-radius: 5px;
}

.plus-icon:hover {
  background-color: #0d494cab;
}

.document-icon {
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 5px;
  height: 40px;
  border-radius: 8px;
  margin: 0 5px;
}

.document-icon:hover {
  background-color: var(--sidemenu-background-color-hover);
  color: var(--primary-color);
}

.sidebar-menu-items {
  background-color: var(--sidemenu-background-color);
  border: none !important;
  margin: 10px 0px;
}

.space-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}

.space-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  font-size: 1.5rem;
  border-bottom: 1px solid rgb(227, 232, 237);
  padding-right: 8px;
}

.space-title {
  padding: 0 20px;
  width: 35%;
  max-width: 540px;
}

.title-input:hover {
  background-color: rgb(227, 232, 237);
}

.title-input:focus {
  background-color: rgb(227, 232, 237);
  outline: none;
}

.space-sub-header {
  height: 50px;
  border-bottom: 1px solid rgb(227, 232, 237);
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding-left: 20px !important;
}

.space-body {
  display: flex;
  height: 100%;
  position: relative;
}

.layout-component {
  width: 83%;
  overflow-y: auto;
}

/* .space-editor {
      min-width: 85%;
      overflow-x: auto;
      overflow-y: auto;
  } */
.tree-wrapper {
  height: 100%;
  max-height: calc(100vh - 172px);
  overflow-y: auto;
}

.menu-list-folder-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px 10px 2px;
}

.custom-submenu .ant-menu-submenu-arrow {
  display: none !important;
}

.flex-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-centered {
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-antmenu {
  overflow: auto !important;
}

/* .user-space-plus-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 7px 0;
  border-radius: 8px;
  font-size: 15px;
  margin-right: 5px;
  background-color: rgba(0, 0, 0, 0.05);
  gap: 10px;
} */

/* .user-space-plus-icon-wrapper:hover {
  background-color: rgba(0, 0, 0, 0.15);
} */

/* styles for google sign in widget */

.gsi-material-button {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-appearance: none;
  user-select: none;
  appearance: none;
  background-color: WHITE;
  background-image: none;
  border: 1px solid #747775;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #1f1f1f;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  height: 40px;
  letter-spacing: 0.25px;
  outline: none;
  overflow: hidden;
  padding: 0 12px;
  position: relative;
  text-align: center;
  -webkit-transition:
    background-color 0.218s,
    border-color 0.218s,
    box-shadow 0.218s;
  transition:
    background-color 0.218s,
    border-color 0.218s,
    box-shadow 0.218s;
  vertical-align: middle;
  white-space: nowrap;
  width: auto;
  max-width: 400px;
  min-width: min-content;
}

.gsi-material-button .gsi-material-button-icon {
  height: 20px;
  margin-right: 12px;
  min-width: 20px;
  width: 20px;
}

.gsi-material-button .gsi-material-button-content-wrapper {
  -webkit-align-items: center;
  align-items: center;
  display: flex;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  height: 100%;
  justify-content: space-between;
  position: relative;
  width: 100%;
}

.gsi-material-button .gsi-material-button-contents {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
}

.gsi-material-button .gsi-material-button-state {
  -webkit-transition: opacity 0.218s;
  transition: opacity 0.218s;
  bottom: 0;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.gsi-material-button:disabled {
  cursor: default;
  background-color: #ffffff61;
  border-color: #1f1f1f1f;
}

.gsi-material-button:disabled .gsi-material-button-contents {
  opacity: 38%;
}

.gsi-material-button:disabled .gsi-material-button-icon {
  opacity: 38%;
}

.gsi-material-button:not(:disabled):active .gsi-material-button-state,
.gsi-material-button:not(:disabled):focus .gsi-material-button-state {
  background-color: #303030;
  opacity: 12%;
}

.gsi-material-button:not(:disabled):hover {
  -webkit-box-shadow:
    0 1px 2px 0 rgba(60, 64, 67, 0.3),
    0 1px 3px 1px rgba(60, 64, 67, 0.15);
  box-shadow:
    0 1px 2px 0 rgba(60, 64, 67, 0.3),
    0 1px 3px 1px rgba(60, 64, 67, 0.15);
}

.gsi-material-button:not(:disabled):hover .gsi-material-button-state {
  background-color: #303030;
  opacity: 8%;
}
.gsi-material-button:hover {
  background: white !important;
}
/* login page styles */

.login-container {
  align-items: center;
  background-color: #fff;
  border-radius: 0.75rem;
  display: flex;
  justify-content: center;
  left: 50%;
  overflow: hidden;
  padding: 6rem 1rem 4rem;
  position: absolute;
  text-align: center;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: min(100%, 1140px);
}

.svg-container {
  transform: translate(-110px, 10px);
}

.image-container {
  display: flex;
  align-items: center;
  width: 50%;
}

.login-container h1 {
  text-align: center;
  margin-bottom: 2px;
}

.login-container h2 {
  text-align: center;
  margin-bottom: 2px;
}

.login-container h3 {
  text-align: center;
  margin-bottom: 30px;
}

.login-container label {
  margin-bottom: 8px;
}

.login-container input {
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 16px;
  width: 100%;
}

.login-container input:focus {
  outline: none;
  border-color: var(--primary-color);
  color: #000000 !important;
  background-color: whitesmoke !important;
  background: whitesmoke !important;
}

@media (max-width: 767px) {
  .login-container {
    align-items: center;
    background-color: #fff;
    border-radius: 0.75rem;
    display: flex;
    justify-content: center;
    left: 50%;
    overflow: hidden;
    padding: 6rem 1rem 4rem;
    position: absolute;
    text-align: center;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 80%;
  }
  .image-container {
    display: none;
  }
  .login-logos {
    flex-direction: column;
  }
}

/* Admin layout styles */

.admin-layout-header {
  background-color: var(--sidemenu-background-color);
}

/* organization page styles */

.orgnization-component-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  min-height: 100vh;
}

.organization-second-wrappper {
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 20px;
  min-width: 50%;
}

.organization-title {
  text-align: center;
  padding: 20px 0px;
  font-weight: 500;
  font-size: 25px;
  color: var(--primary-color);
}

.organization-form-wrapper {
  margin: 30px 0px;
}

.radio-container {
  text-align: center;
}

/* integrations page styles */

.integration-page-wrapper {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  padding: 20px 40px;
}

.integration-title {
  margin: 0;
  font-size: 32px;
  font-weight: 500;
  text-align: left;
}

.card-wrapper {
  min-height: 16vh;
  width: 17%;
  transition: transform 0.3s ease;
  box-shadow:
    0px 1px 2px 0px rgba(0, 0, 0, 0.15),
    0px -1px 1px 0px rgba(0, 0, 0, 0.05);
  cursor: pointer;
}

.card-wrapper:hover {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.integration-cards-container {
  display: flex;
  justify-content: flex-start;
  gap: 4rem;
}

.org-list-wrapper {
  min-height: 100vh;
}

.org-form-wrapper {
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
  width: 30%;
  min-height: 200px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.org-title {
  font-size: 20px;
  font-weight: 600;
}

.org-select-wrapper {
  margin: 30px auto;
  width: 100%;
}

.bitbucket_form_wrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.bitbucket_workspace_form_wrapper {
  padding: 2rem;
  width: 100%;
  min-width: 300px;
  max-width: 600px;
  box-shadow:
    rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
}

.bitbucket_workspace_form_wrapper > .bitbucket_workspace_form {
  width: 100%;
}

.bitbucket_form_control .field_label {
  display: block;
  font-size: 1rem;
  font-weight: 600;
  padding: 0 0 0.25rem;
}

.user-email-userspace > span:first-child {
  display: inline-block;
  font-size: 15px;
  line-height: 15px;
  font-weight: 500;
}

.space-sidebar-menu-wrapper .ant-tree-treenode:hover .option-button {
  display: flex !important;
  opacity: 1 !important;
}
.space-sidebar-menu-wrapper .ant-tree-treenode .option-button {
  display: flex !important;
}

.generic.modal-body .modal-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  margin-right: 2rem;
  padding-bottom: 1rem;
}

.generic.modal-body .modal-content {
  padding-top: 0.25rem;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
}

.generic.modal-body .preview.modal-header {
  margin: 0px !important;
}

.preview.generic .modal-header-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.preview.generic .modal-header-wrapper .modal-header-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.preview.generic .remirror-editor-wrapper {
  margin-left: 0;
  padding: 0;
}

.ant-modal.template .modal-template-card {
  display: flex;
  min-height: 46px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-size: 16px;
  font-weight: 400;
  padding: 4px 0;
  cursor: pointer;
  border-bottom: 1px solid #dbdbdb;
}

.workspace.one-doc-skeleton {
  margin: 16px 5px;
}

.w-full {
  width: 100%;
}

.h-full {
  height: 100%;
}

.items-center {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.flex-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.space-breadcrumb {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.access-role-page#access-role-page {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.access-form-wrapper {
  width: 100%;
  max-width: 550px;
}

.access-role-form .form-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
}

:where(.json-editor-wrapper.overflow-hidden) {
  height: calc(100vh - 110px);
  overflow-y: hidden;
}

:where(.overflow-auto) {
  height: 100%;
  overflow-y: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

:where(.json-editor-wrapper > .overflow-auto)::-webkit-scrollbar {
  display: none;
}

:where(.settings-sidebar) {
  max-width: 300px;
  width: 100%;
}

.settings-layout {
  user-select: none;
  cursor: default;
}

.settings-layout .organization-wrapper {
  margin-bottom: 1rem;
}

.settings-layout .organization-name {
  font-size: 1.5rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  font-weight: 600;
  cursor: pointer;
}

.sidebar-menus .sidebar-menus-title {
  font-size: 1rem;
  font-weight: 500;
  padding: 8px;
  cursor: default;
}

.user-dialog-wrapper {
  margin-left: auto;
}

.sub-setting-page {
  padding: 1rem 2rem;
  width: 100%;
  height: 100%;
}

.sub-setting-page .sub-setting-header {
  text-transform: capitalize;
  font-size: 1rem;
  font-weight: 500;
  padding: 0.5rem 2rem;
  background-color: #eee;
}

.sub-setting-page .sub-setting-content-wrapper {
  border: 1px solid #eee;
  padding: 1rem 2rem;
  box-shadow:
    0 4px 6px -1px rgb(0 0 0 / 0.1),
    0 2px 4px -2px rgb(0 0 0 / 0.1);
  margin-bottom: 1rem;
}

.sub-setting-content-wrapper .sub-setting-subtitle {
  padding: 0.125rem 0.5rem;
  background-color: #f1f1f1;
  margin-bottom: 0.5rem;
}

.sub-setting-subcontent {
  width: 100%;
  margin-top: 1rem;
  padding: 0 2rem;
}

:where(.sub-setting-subcontent).flex-center {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.documentation-tab-wrapper {
  color: var(--editor-heading-font-color) !important;
}

.organization-name {
  color: var(--primary-font-color);
}

.side-menu-search-icon:hover {
  background-color: var(--sidemenu-background-color-hover);
  color: var(--primary-color) !important;
}

.menu-items-spinner-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  padding-top: 2rem;
}

.space-sidebar-menu-wrapper {
  font-size: 16px !important;
}

.user-space-plus-icon-wrapper {
  background: var(--primary-color);
  color: #fff !important;
}

.button:hover span {
  color: #fff !important;
}

.button:hover span {
  color: var(--primary-color) !important;
}

.space-header {
  background-color: var(--sidemenu-background-color);
}

.sidebar-menu-items {
  overflow-y: auto !important;
}

.user-space-plus-icon-wrapper .add-button {
  border: none !important;
  outline: none !important;
}

.user-space-plus-icon-wrapper .add-button:hover {
  border: none !important;
}
.user-space-plus-icon-wrapper {
  flex-direction: row-reverse;
  border: none;
  font-weight: 600;
}

.side-menu-search-box {
  margin: 20px 0 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.space-header .space-title input {
  margin: 5px 0;
  border: 1px solid var(--primary-color);
}

.generic.modal-title {
  font-size: 16px;
  font-weight: 500;
  padding: 16px 24px 16px 24px;
}

.generic.modal-icon svg {
  fill: var(--primary-color);
}

.remirror-theme {
  width: 100%;
}

.remirror-editor.ProseMirror {
  overflow-y: auto !important;
}

form#adam-upload-form {
  margin-top: 24px;
}

form#adam-upload-form div label {
  font-size: 16px;
  font-weight: 500;
  color: var(--primary-color) !important;
}

.sidebar-menus .sidebar-menus-title div {
  color: #fff !important;
}

.settings-layout .organization-name {
  display: flex;
  justify-content: center;
  align-items: center;
}

.settings-layout .organization-name div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.span-12 {
  width: 120px !important;
}

.sub-setting-content-wrapper .sub-setting-subtitle {
  background: var(--primary-color) !important;
  color: #fff !important;
}

.sub-setting-page .sub-setting-header {
  background: var(--primary-color) !important;
  color: #fff;
}

.sub-setting-content-wrapper .sub-setting-subtitle {
  background: var(--primary-color) !important;
  color: #fff !important;
}

.bitbucket-page {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  min-height: 100%;
  margin: 0;
  padding: 16px;
  padding-top: 96px;
  position: relative;
  height: 100vh;
  width: 100%;
}

.bitbucket-page::before {
  background: linear-gradient(0deg, rgba(255, 180, 0, 0.5) 0, rgba(255, 180, 0, 0) 100%);
  content: '';
  height: 100vh;
  left: 50%;
  position: fixed;
  transform: translateX(-50%) translateY(50%);
  width: 100%;
  z-index: -1;
}

.card-third-party {
  max-width: 450px;
  width: 100%;
  background: #ffffff;
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.04),
    0 4px 16px -4px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  padding: 32px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

h1.card-title-third-party {
  font-size: 23px;
  text-transform: capitalize;
  text-align: center;
  font-weight: 600;
}

.card-content-third-party p {
  font-size: 14px;
  color: #000;
}

.card-content-third-party p:nth-child(2) {
  font-size: 12px;
}

.card-content-third-party a {
  text-decoration: none;
  font-weight: 400;
  font-size: 12px;
}

.count-down-wrapper {
  background-color: rgba(255, 180, 0, 0.5);
  height: 30px;
  width: 30px;
  border-radius: 25px;
  transition-duration: 4s;
  transition-property: background-color;
  animation-name: grow;
  animation-duration: 9s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  -webkit-transition-property: -webkit-transform background-color;
  -webkit-transition-duration: 4s;
  -moz-transition-property: -moz-transform background-color;
  -moz-transition-duration: 4s;
  -webkit-animation-name: grow;
  -webkit-animation-duration: 9s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  -moz-animation-name: grow;
  -moz-animation-duration: 9s;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: linear;
}

@keyframes grow {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
    background-color: red;
  }
  100% {
    transform: scale(1);
  }
}

p.count-down-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

span.count-down,
p.count-down {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.card-content-third-party {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

:where(.css-dev-only-do-not-override-m4timi).upload-modal.small {
  width: unset !important;
  min-width: 520px !important;
  max-width: 520px !important;
}

:where(.css-dev-only-do-not-override-m4timi).upload-modal.large {
  width: unset !important;
  min-width: 520px !important;
  max-width: 900px !important;
}

.para-link {
  text-align: center;
  width: 83%;
}

.integration-page-wrapper {
  max-width: calc(980px + 8rem) !important;
  padding-left: 6rem !important;
  padding-right: 6rem !important;
}

.integration-title {
  text-align: left;
  margin: 0;
}
.integration-img-wrapper {
  width: 50%;
}
.int-img {
  width: -moz-available;
}
.integration-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4rem;
}

.int-img {
  width: -moz-available;
  height: 115px;
  position: relative;
  top: 22%;
}

.para-int {
  margin: 0 auto;
}
.inner-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.integration-cards-container {
  flex-direction: column;
  gap: 0rem;
  margin-top: -1rem;
}

.card-inner-content h2 {
  font-size: 20px;
  font-weight: 500;
  color: var(--editor-heading-font-color);
}

.integration-cards-container.inter-cards .ant-card {
  width: 45%;
  min-height: auto !important;
}

.integration-cards-container .ant-card .card-inner-wrapper {
  justify-content: flex-start !important;
  align-items: flex-start !important;
  gap: 1rem !important;
}
.card-inner-container-content {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.integration-cards-container .ant-card.ant-card-bordered.card-wrapper.css-dev-only-do-not-override-f7vrd6 {
  width: 45%;
  min-height: auto !important;
}
.integration-cards-container .ant-card.ant-card-bordered.card-wrapper .ant-card-body {
  padding: 16px 16px 0px;
  border: 1px solid rgba(0, 0, 0, 0);
}
.card-inner-para p {
  margin: 0 !important;
  color: var(--editor-heading-font-color) !important;
}

.content-link {
  color: var(--editor-heading-font-color);
}

.content-link div:first-child {
  font-weight: 600;
}

.sub-text {
  position: relative;
  top: -8%;
}

.card-inner-container-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 8px;
}

h2 {
  color: #262930;
}

.integration-cards-container .ant-card {
  width: 45% !important;
  height: fit-content;
}

/* file and workspace settings modal */

.announcement-modal {
  --modal-content-width: 900px;
  --modal-content-height: 650px;
  width: var(--modal-content-width) !important;
}
.announcement-modal .ant-modal-content {
  padding: 0px;
}
.template .ant-modal-content {
  padding: 0px;
}

.file-setting-modal,
.workspace-setting-modal {
  --modal-content-width: 900px;
  --modal-content-height: 650px;
  width: var(--modal-content-width) !important;
}

.file-setting-modal .file-setting-content,
.workspace-setting-modal .workspace-setting-content {
  position: relative;
  overflow: auto;
  padding-right: 1rem;
  flex: 1;
}

.file-setting-modal .file-setting-header,
.workspace-setting-modal .workspace-setting-header {
  padding: 1rem;
  padding-left: 0;
  margin-bottom: 16px !important;
  border-bottom: 1px solid #d6d6d6;
}

.file-setting-modal .file-setting-header h1,
.workspace-setting-modal .workspace-setting-header h1 {
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 700 !important;
  margin: 0;
}

.file-setting-modal .tab-setting-group,
.workspace-setting-modal .tab-setting-group {
  margin-bottom: 1rem;
}

.file-setting-modal .tab-setting-group .tab-setting-header h1,
.workspace-setting-modal .tab-setting-group .tab-setting-header h1 {
  font-family: 'Inter', sans-serif;
  font-size: 18px !important;
  font-weight: 600;
  margin: 0;
}

.workspace-setting-modal .info,
.file-setting-modal .info {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.workspace-setting-modal .info p,
.file-setting-modal .info p {
  margin: 0;
  font-family: 'Inter', sans-serif;
}

.workspace-setting-modal .info p.info-header,
.file-setting-modal .info p.info-header {
  font-weight: 500;
}

.setting-item-header {
  margin-bottom: 6px;
}

.setting-item-header-content {
  /* color: var(--editor-text-font-color); */
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 400;
  margin: 0;
}

.tab-setting-item.flex-row .setting-item-header-content {
  max-width: 300px;
  margin-top: 5px;
}

.tab-setting-item.flex-row .setting-item-header-content.lg {
  max-width: 500px;
}

.setting-item-header-content.main {
  font-size: 15px;
  font-weight: 500;
}

.file-rename-content,
.workspace-rename-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
}

.file-rename-content input:hover,
.workspace-rename-content input:hover,
.login-container input:hover,
.manage-permission-wrapper input:hover {
  border-color: #ccc;
}

.file-rename-content input:focus,
.workspace-rename-content input:focus,
.manage-permission-wrapper input:focus {
  border-color: var(--primary-color);
  color: var(--editor-heading-font-color);
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
}

.tab-setting-header {
  margin-bottom: 4px;
}

.tab-setting-content {
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
}
.tab-setting-content .tab-setting-item {
  border-bottom: 1px solid #ddd;
  padding-bottom: 16px;
  margin-bottom: 16px;
}

.tab-setting-content .tab-setting-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.file-setting-modal .copy-code-modal .copy-code-modal-header h1 {
  font-size: 20px;
  font-family: 'Inter', sans-serif;
  margin: 0;
}

.file-setting-modal .copy-code-modal .copy-code-modal-header p {
  font-size: 16px;
  font-family: 'Inter', sans-serif;
  margin: 0;
}

.file-setting-modal .copy-code-modal .copy-code-modal-header {
  margin-bottom: 16px;
}

.copy-code-modal .copy-code-toolbar {
  border: 1px solid #ddd;
  padding: 0.25rem 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.copy-code-modal .copy-code-toolbar .icon-btn {
  border: 1px solid #ddd;
}

.copy-code-modal .copy-code-toolbar .icon-btn svg {
  fill: #777 !important;
}

.copy-code-modal .copy-code-modal-content {
  border: 1px solid #ddd;
  border-top: 0;
  width: 100%;
  overflow: hidden;
  padding: 0 !important;
}

.copy-code-modal .copy-code-modal-content pre {
  width: 100%;
  margin: 0;
  padding: 0.5rem 1rem;
  color: #fff;
  background-color: rgb(26, 26, 103);
  overflow: auto;
}

.tab-setting-item .setting-item-feedback {
  display: inline-block;
  padding: 0.25rem 1rem;
  margin-top: 0.5rem;
  border-radius: 4px;
  font-family: 'Inter', sans-serif;
}

.tab-setting-item .setting-item-feedback.error {
  color: red;
  border: 1px solid rgba(255, 0, 0, 1);
  background-color: rgba(255, 0, 0, 0.1);
}

.tab-setting-item .setting-item-feedback.success {
  color: green;
  border: 1px solid rgba(0, 255, 0, 1);
  background-color: rgba(0, 255, 0, 0.1);
}

button {
  align-items: center;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
  flex-basis: auto;
  flex-direction: row;
  flex-grow: 0;
  flex-shrink: 0;
  justify-content: center;
  outline: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  text-decoration-line: none;
  padding-inline: var(--padding-inline-size, --sp-spacing-300);
}

button:disabled {
  opacity: 0.7;
}

.openapi-modal .upload-modal-header h1,
.openapi-editor .openapi-header h1,
.copy-code-modal .copy-code-modal-header h1,
.rename-template .rename-template-header h1,
.bitbucket-import-template .bitbucket-import-template-header h1,
.upload-toolbar-modal .upload-toolbar-header h1,
.onedoc-modal .onedoc-modal-header h1 {
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  margin: 0;
}

.openapi-modal .upload-modal-header p,
.openapi-editor .openapi-header p,
.copy-code-modal .copy-code-modal-header p,
.rename-template .rename-template-header p,
.bitbucket-import-template .bitbucket-import-template-header p,
.upload-toolbar-modal .upload-toolbar-header p,
.onedoc-modal .onedoc-modal-header p {
  margin: 0;
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  color: var(--sp-color-text-muted);
}

.openapi-modal .upload-modal-content,
.rename-template .rename-template-content,
.bitbucket-import-template .bitbucket-import-template-content,
.upload-toolbar-modal .upload-toolbar-content,
.onedoc-modal .onedoc-modal-content {
  /* padding: 1rem; */
  padding-top: 0;
}

.rename-template .rename-template-content {
  margin-top: 8px;
  margin-bottom: 8px;
}

.rename-input-group .iconinput-wrapper {
  cursor: pointer;
}

.rename-template .titleinput-wrapper,
.onedoc-modal .input-wrapper {
  flex: 1;
}

.openapi-modal input,
.rename-template input,
.upload-toolbar-modal .direct-link-upload-template input,
.rename-template .iconinput-wrapper,
.onedoc-modal .input-wrapper input {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  border-color: rgb(223, 225, 230);
  /* color: rgb(9, 30, 66); */
  cursor: text;
  border-radius: 3px;
  border-width: 2px;
  border-style: solid;
  box-sizing: border-box;
  transition:
    background-color 0.2s ease-in-out 0s,
    border-color 0.2s ease-in-out 0s;
  line-height: 1.42857;
  padding: 8px 6px;
  height: 36px;
}

.openapi-modal input:focus,
.rename-template input:focus,
.upload-toolbar-modal .direct-link-upload-template input:focus,
.onedoc-modal .input-wrapper input:focus {
  /* background-color: rgb(255, 255, 255); */
  border-color: var(--primary-color);
}
integration-info {
  overflow-y: auto;
  max-width: 500px;
}

.openapi-modal .titleinput-wrapper .titleinput-label,
.rename-template .titleinput-wrapper .titleinput-label,
.upload-toolbar-modal .direct-link-upload-template .direct-link-label,
.rename-template .iconinput-label,
.onedoc-modal .input-label-wrapper .input-label {
  margin: 0;
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 4px;
}

.openapi-modal .titleinput-wrapper .titleinput-error,
.rename-template .titleinput-wrapper .titleinput-error,
.upload-toolbar-modal .direct-link-error,
.onedoc-modal .input-wrapper .input-error-wrapper {
  margin: 0;
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 400;
  margin-top: 8px;
  padding: 0.25rem 1rem;
  color: rgb(255, 0, 0);
  background-color: rgba(255, 0, 0, 0.1);
  border-radius: 4px;
}

.openapi-modal .dropbox-wrapper,
.upload-toolbar-modal .local-file-upload-template .dropbox-wrapper {
  margin-top: 12px;
}

.dropbox-wrapper .dragger-text {
  padding: 0.5rem 0rem 0;
  font-size: 15px;
}

.dropbox-wrapper .dragger-hint {
  margin-bottom: 0.5rem;
  font-weight: 400;
}

.openapi-modal .upload-modal-footer,
.openapi-editor .openapi-editor-footer,
.rename-template .rename-template-footer,
.bitbucket-import-template .bitbucket-import-template-footer,
.upload-toolbar-modal .upload-toolbar-footer,
.onedoc-modal .onedoc-modal-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  /* padding: 0 1rem 1rem; */
  margin-top: 1rem;
}

.openapi-editor .openapi-content {
  height: 500px;
}
.openapi-modal.large,
.openapi-modal.large .ant1-modal-content,
.openapi-modal.large .ant1-modal-body,
.workspace-modal.large,
.workspace-modal.large .ant1-modal-content,
.workspace-modal.large .ant1-modal-body {
  width: 800px !important;
}

.onedoc-modal.publish-modal,
.onedoc-modal.publish-modal .ant1-modal-content,
.onedoc-modal.publish-modal .ant1-modal-body {
  width: 600px !important;
}

.copy-code-modal .copy-code-modal-body {
  padding: 1rem;
  padding-top: 0;
}

.openapi-editor .openapi-content {
  overflow: hidden;
}

.openapi-editor .openapi-inner-content {
  overflow: auto;
  height: 100%;
}

.openapi-editor .openapi-editor-error {
  margin: 0 1rem 1rem;
  color: rgb(255, 0, 0);
  background-color: rgba(255, 0, 0, 0.1);
  font-family: 'Inter', sans-serif;
  padding: 0.5rem 1.25rem;
  border-radius: 4px;
}

.spinner-wrapper,
.spinner-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.spinner-wrapper .anticon svg {
  fill: var(--sp-color-text-primary) !important;
}

.settings-tab-group {
  border: 1px solid var(--sp-color-border-base);
  margin: 2rem;
  border-radius: 8px;
}

.settings-tab-group .settings-tab-header {
  padding: 1rem;
  border-bottom: 1px solid var(--sp-color-border-base);
}

.settings-tab-group .settings-tab-header h1 {
  font-family: 'Inter', sans-serif;
  color: var(--editor-heading-font-color);
  margin: 0;
  font-size: 20px;
  font-weight: 500;
}

.settings-tab-content .settings-tab-item .tab-item-header p {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: var(--editor-heading-font-color);
}

.settings-tab-content .settings-tab-item {
  padding: 1rem;
  border-bottom: 1px solid var(--sp-color-border-base);
}

.settings-tab-content .settings-tab-item:last-child {
  border-bottom: none;
}

.settings-tab-content .settings-tab-item .tab-item-content p {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
}

.workspace-settings-page {
  margin: 2rem;
  border-radius: 8px;
  border: 1px solid var(--sp-color-border-base);
}

.workspace-settings-page .workspace-settings-header {
  padding: 1rem;
  border-bottom: 1px solid var(--sp-color-border-base);
}

.workspace-settings-page .workspace-settings-header h1 {
  margin: 0;
  font-size: 20px;
  color: var(--sp-color-text-base);
  font-family: 'Inter', sans-serif;
}

.workspace-settings-page .workspace-settings-content {
  padding: 1rem;
}

.settings-layout .sidemenu-wrapper .organization-wrapper {
  height: 60px;
}

.settings-layout .sidemenu-wrapper .organization-wrapper .organization-name {
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 500;
}

.sidebar-main-menu {
  border-bottom: 1px solid var(--sp-color-badge-bg-primary);
}

.sidebar-main-menu .sidebar-menu-item,
.sidebar-menu .sidebar-menu-item {
  color: var(--primary-icon-color);
  border-radius: 4px;
  background-color: transparent;
  padding: 1rem 1rem;
}

.sidebar-main-menu .sidebar-menu-item p,
.sidebar-menu .sidebar-menu-item p {
  margin: 0;
}

.sidebar-menu .sidebar-menu-header h1 {
  font-family: 'Inter', sans-serif;
  color: var(--sp-color-text-inverted);
  font-size: 20px;
  font-weight: 600;
  padding: 0.5rem 1rem;
}

.workspace-modal .checkbox-wrapper {
  margin-top: 16px;
}

.workspace-modal .checkbox-wrapper label span:last-child {
  display: inline-block;
  font-family: 'Inter', sans-serif;
  color: var(--sp-color-text-menu-default);
  font-size: 14px;
  font-weight: 500;
}

.rename-template .rename-template-header {
  padding-right: 3rem;
}

.bitbucket-import-template .bitbucket-import-template-content {
  min-height: 320px;
}

.upload-toolbar-modal .upload-toolbar-header {
  padding-bottom: 0;
}

.rename-template .rename-input-group {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1rem;
}

.onedoc-modal .note,
.onedoc-modal .input-note {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: var(--sp-color-text-primary);

  padding: 8px;
  border-radius: 4px;
  margin-top: 8px;
}

.external_link-wrapper a {
  display: inline-block;
  color: var(--sp-color-text-primary) !important;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
}

.external_link-wrapper .anticon svg {
  fill: var(--sp-color-text-primary) !important;
}

.access-form-wrapper .checkbox-wrapper label {
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
}

.manage-permission-wrapper {
  border: 1px solid var(--sp-color-action-bg-nested-hover);
  padding: 2rem 1rem;
  border-radius: 0.25rem;
  height: calc(100vh - 60px);
  overflow-y: auto;
  overflow-x: hidden;
}

.manage_permission_settings {
  max-width: 550px;
  padding: 1rem;
}

.manage_permission_settings .setting-item-header {
  margin-bottom: 1rem;
}

.manage_permission_settings .setting-item-header .setting-item-header-content.main {
  margin-bottom: 0.5rem;
  color: var(--editor-heading-font-color);
}

.published-btn.success {
  background-color: rgba(0, 255, 0, 0.1) !important;
  color: #0d4f10 !important;
  border-color: rgba(0, 255, 0, 0.1) !important;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
}

.iconinput-wrapper .anticon svg {
  fill: black !important;
}

.or-divider {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.or-divider .line {
  display: inline-block;
  width: 100%;
  height: 1px;
  background-color: var(--sp-color-text-menu-dark-default);
}

.or-divider .text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 600;
}
.icons-selector {
  width: 220px !important;
  height: 180px !important;
}

.icons-selector .rc-virtual-list .rc-virtual-list-holder {
  height: 180px !important;
}

.icons-selector .rc-virtual-list-holder-inner {
  display: grid !important;
  grid-template-columns: repeat(4, 1fr) !important;
  gap: 10px !important;
  padding: 10px !important;
}

.flex-1 {
  flex: 1;
}

.group-menu .group-menu-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
}

.group-menu .group-menu-header h1 {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #fff !important;
}

.sidemenu-wrapper,
.sidemenu-wrapper-collapsed {
  transition: width 0.3s ease;
}

.sidemenu-wrapper-collapsed {
  width: 5%;
}

.content-wrapper {
  transition: width 0.3s ease;
}

.ant-menu-inline-collapsed.sidebar-menu-items {
  width: unset !important;
  margin-left: 11px;
}

.space-breadcumb {
  flex-grow: 1;
}

.external_link-wrapper a {
  display: flex;
  align-items: center;
  gap: 5px;
}

.workspace-scroller {
  /* height: 100%; */
  /* max-height: 75vh; */
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1;
}

.custom-btn:hover {
  border: none !important;
}

.space-sub-header-actions .editor-save-status {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.25rem;
}

.rotate {
  animation: rotateAnimation 2s linear infinite;
}

.ant-tree .ant-tree-treenode .icon {
  width: 18px;
  height: 18px;
  /* other styles if needed */
}

#verificationCode,
#phoneNumber {
  max-width: none;
}
@keyframes rotateAnimation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
}

/* workspace css */
.sidebar-menu-items .ant-menu-item {
  padding: 0.125rem 0.5rem !important;
  border-radius: 4px !important;
  margin: 0;
}

.sidebar-menu-items .ant-menu-item:hover .option-button {
  display: flex !important;
  opacity: 1 !important;
}

.sidebar-menu-items .ant-menu-title-content span {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.sidebar-menu-items .ant-menu-title-content .menu-list-wrapper {
  margin-left: 0.75rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  flex: 1;
}

.sidemenu-wrapper-collapsed .ant-menu-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 0 5px;
  width: 100%;
  max-width: 60px;
  padding: 0px !important;
  border: none;
  outline: none;
}

.sidemenu-wrapper-collapsed .ant-menu-item .ant-menu-title-content {
  width: 0px !important;
  height: 0px !important;
}

.tree-wrapper .ant-tree-treenode .ant-tree-title .text-content {
  flex: 1;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  /* max-width: 190px; */
}

.icon-selector-button:hover {
  background-color: var(--emoji-hover-color) !important;
}

.tab-setting-item .setting-item-feedback {
  display: inline-block;
  padding: 0.25rem 1rem;
  margin-top: 0.5rem;
  border-radius: 4px;
  font-family: 'Roboto', sans-serif;
}

.setting-item-feedback-error {
  color: red;
  margin-top: 4px;
}

.setting-item-feedback-success {
  color: green;
  margin-top: 4px;
}
.user-settings-title {
  margin: 0;
  padding-left: 10px;
  color: var(--primary-color);
  font-size: 18px;
}

.settings-arrow {
  font-size: 24px;
  color: var(--primary-color);
  padding-bottom: 10px !important;
}

.space-non-title {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
}
.ant-select-selector {
  background-color: var(--box-background-color);
}

.swagger-ui .renderedMarkdown p,
.swagger-ui .renderedMarkdown ul,
.swagger-ui .renderedMarkdown li {
  color: var(--editor-heading-font-color);
}

.swagger-ui .scheme-container {
  color: var(--editor-heading-font-color);
  background-color: var(--sidemenu-background-color);
  overflow-x: auto;
}
.settings-sider {
  background: var(--sidemenu-background-color) !important;
}
.settings-menu {
  background-color: var(--sidemenu-background-color) !important;
}

.login-text .ant-form-item-required {
  color: #000000 !important;
}

.swagger-ui .opblock .opblock-summary-description {
  color: var(--editor-text-font-color);
}
.swagger-ui .opblock .opblock-summary-path {
  color: var(--editor-heading-font-color);
}
.swagger-ui .info .title {
  color: var(--primary-color);
}
.ͼ2 .cm-gutters {
  background-color: var(--sidemenu-background-color);
}
.swagger-ui .opblock-tag {
  color: var(--editor-heading-font-color);
}

.jsonEditor .ͼe {
  color: var(--editor-text-font-color);
}
.swagger-ui .expand-methods svg,
.swagger-ui .expand-operation svg,
.swagger-ui svg:not(:root) {
  fill: var(--editor-heading-font-color);
}

.swagger-ui td,
.swagger-ui h4,
.swagger-ui h5,
.swagger-ui .opblock-description-wrapper p,
.btn.try-out__btn {
  color: var(--editor-heading-font-color) !important;
}

.swagger-ui .opblock .opblock-section-header {
  background: var(--box-background-color);
}

.btn.btn-clear.opblock-control__btn {
  color: var(--editor-heading-font-color);
}
.star-icon-filled {
  color: #ffab00;
}

/* leftbar-slider */
.leftbar {
  position: relative;
}
.leftbar:hover {
  border-right: 1px solid var(--primary-color, #1890ff) !important;
}
.leftbar-slider {
  position: absolute;
  right: -12px;
  top: 100px;
  transition: all 0.3s ease;
  border: 1px solid var(--border-color, #d9d9d9);
  width: 24px !important;
  height: 24px !important;
  min-width: unset !important;
}
.leftbar:hover .leftbar-slider {
  border-color: var(--primary-color, #1890ff) !important;
  color: var(--primary-color, #1890ff) !important;
}
.sidemenu-wrapper-collapsed > .sidebar-menu-items {
  margin-top: 30px;
}
.space-sidebar-menu-wrapper .ant-tree-treenode {
  overflow: hidden;
}
.ant-switch-inner {
  background-color: #d9d9d9;
}

button > span.ant-btn-icon {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
}

/* For the Switch track when ON */
.ant-switch-checked .ant-switch-inner {
  background-color: var(--primary-color, #1890ff) !important;
}

.ai-feedbacks .ant-table-wrapper .ant-table-pagination {
  display: flex;
  justify-content: center;
}

.ant-divider-horizontal {
  margin: 0px !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;;EAE3B;;yCAEuC;;EAEvC,qBAAqB;EACrB,6BAA6B,EAAE,2BAA2B;EAC1D,+BAA+B,EAAE,uBAAuB;EACxD,8BAA8B;EAC9B,6BAA6B,EAAE,2BAA2B;EAC1D,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;;EAEnC,0CAA0C;EAC1C,2CAA2C;EAC3C,oCAAoC;EACpC,yBAAyB;EACzB,wBAAwB,EAAE,mBAAmB;EAC7C,8BAA8B,EAAE,+CAA+C;EAC/E,8BAA8B,EAAE,wCAAwC;;EAExE,+BAA+B;EAC/B,oCAAoC,EAAE,oCAAoC;EAC1E,yDAAyD;EACzD,6BAA6B;EAC7B,0BAA0B,EAAE,+BAA+B;EAC3D,wBAAwB,EAAE,gDAAgD;EAC1E,uBAAuB,EAAE,iCAAiC;;EAE1D,wDAAwD;EACxD,+BAA+B,EAAE,uCAAuC;EACxE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;;EAEzC,qBAAqB;EACrB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB,EAAE,sBAAsB;EAC3C,mBAAmB,EAAE,kCAAkC;EACvD,2CAA2C,EAAE,kBAAkB;AACjE;;AAEA;EACE,mBAAmB,EAAE,iCAAiC;AACxD;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB;;mBAEiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;EACf,+CAA+C;AACjD;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;;IAOI;;AAEJ;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,cAAc;EAChB;EACA;IACE,0CAA0C;EAC5C;AACF;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,+BAA+B;EAC/B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oCAAoC;EACpC,oCAAoC;EACpC,OAAO;EACP,kDAAkD;EAClD,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,kCAAkC;EAClC,UAAU;EACV,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kDAAkD;AACpD;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE,qCAAqC;AACvC;;AAEA,qCAAqC;;AAErC;EACE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,2CAA2C;EAC3C,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB;;;qBAGmB;EACnB;;;qBAGmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,SAAS;EACT,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE;;wCAEsC;EACtC;;wCAEsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,sBAAsB;;AAEtB;EACE,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,wCAAwC;EACxC,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,wCAAwC;IACxC,gCAAgC;IAChC,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,aAAa;AACf;AACA,wBAAwB;;AAExB;EACE,kDAAkD;AACpD;;AAEA,6BAA6B;;AAE7B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;;AAE7B;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,+BAA+B;EAC/B;;wCAEsC;EACtC,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sCAAsC;;EAEtC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB;;uCAEqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wBAAwB,EAAE,gBAAgB;EAC1C,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB;;mCAEiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,mDAAmD;EACnD,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sFAAsF;EACtF,WAAW;EACX,aAAa;EACb,SAAS;EACT,eAAe;EACf,2CAA2C;EAC3C,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB;;uCAEqC;EACrC,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,oBAAoB;EACpB,sBAAsB;EACtB,mCAAmC;EACnC,iCAAiC;EACjC,+DAA+D;EAC/D,+BAA+B;EAC/B,yDAAyD;EACzD,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;EAC9B,2CAA2C;EAC3C,yCAAyC;EACzC,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;KAGK;;AAEL;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB,EAAE,sBAAsB;EAC3C,mBAAmB,EAAE,kCAAkC;EACvD,2CAA2C,EAAE,kBAAkB;AACjE;;AAEA;EACE,mBAAmB,EAAE,iCAAiC;AACxD;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,4CAA4C;EAC5C,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;AAC7B;AACA;EACE,wCAAwC;EACxC;IACE,aAAa,EAAE,mBAAmB;EACpC;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;EACxD,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kDAAkD;EAClD,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,wDAAwD;EACxD,2BAA2B;AAC7B;;AAEA;EACE,kDAAkD;EAClD,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;;KAIK;AACL;EACE,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;GAWG;;AAEH;;GAEG;;AAEH,qCAAqC;;AAErC;EACE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB;;;qBAGmB;EACnB;;;qBAGmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,SAAS;EACT,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE;;wCAEsC;EACtC;;wCAEsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,4BAA4B;AAC9B;AACA,sBAAsB;;AAEtB;EACE,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,wCAAwC;EACxC,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,yBAAyB;EACzB,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,wCAAwC;IACxC,gCAAgC;IAChC,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA,wBAAwB;;AAExB;EACE,kDAAkD;AACpD;;AAEA,6BAA6B;;AAE7B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;;AAE7B;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,+BAA+B;EAC/B;;wCAEsC;EACtC,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB;;uCAEqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wBAAwB,EAAE,gBAAgB;EAC1C,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB;;mCAEiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wDAAwD;EACxD,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sFAAsF;EACtF,WAAW;EACX,aAAa;EACb,SAAS;EACT,eAAe;EACf,2CAA2C;EAC3C,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB;;uCAEqC;EACrC,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,oBAAoB;EACpB,sBAAsB;EACtB,mCAAmC;EACnC,iCAAiC;EACjC,+DAA+D;EAC/D,+BAA+B;EAC/B,yDAAyD;EACzD,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;EAC9B,2CAA2C;EAC3C,yCAAyC;EACzC,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,sCAAsC;;AAEtC;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,4CAA4C;AAC9C;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;;EAEE,4BAA4B;EAC5B,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,OAAO;AACT;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;EAChC,eAAe;EACf,2BAA2B;EAC3B,SAAS;AACX;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,gCAAgC;AAClC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;EAGE,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,WAAW;EACX,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,0BAA0B;EAC1B,4DAA4D;AAC9D;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;;EAOE,gCAAgC;EAChC,eAAe;EACf,SAAS;AACX;;AAEA;;;;;;;EAOE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,iCAAiC;AACnC;;AAEA;;;;;EAKE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,OAAO;AACT;;AAEA;;;;;EAKE,gCAAgC;EAChC,eAAe;EACf,gCAAgC;EAChC,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB;;oCAEkC;EAClC,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;;;EAIE,0CAA0C;EAC1C,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;;EAKE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;EAIE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;AACA;;;;;;EAME,uBAAuB;AACzB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sCAAsC;EACtC,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;EAC7C,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oDAAoD;AACtD;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,oDAAoD;AACtD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;;EAEE,gCAAgC;EAChC,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;;EAEE,gCAAgC;EAChC,eAAe;EACf,mCAAmC;;EAEnC,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,wDAAwD;EACxD,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,iDAAiD;EACjD,yBAAyB;EACzB,6CAA6C;EAC7C,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,wDAAwD;AAC1D;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;EAChD,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;AACjB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,kBAAkB;AAClB;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,6CAA6C;AAC/C;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,kDAAkD;EAClD,gBAAgB;AAClB;AACA;EACE,uDAAuD;AACzD;AACA;EACE,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kDAAkD;AACpD;AACA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;AACA;;;EAGE,sCAAsC;AACxC;;AAEA;;;;;EAKE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;AACA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;AACA;EACE,gEAAgE;AAClE;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,8CAA8C;EAC9C,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,sDAAsD;EACtD,+CAA+C;AACjD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,iCAAiC;AACjC;EACE,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["*:not('.space-editor') {\n  margin: 0;\n  padding: 0;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n:root {\n  --sidebar-full-width: 300px;\n\n  /* --sidemenu-background-color: rgb(247, 247, 245);\n    --hover-background-color: #019299ab;\n    --primary-color: rgb(124, 58, 237); */\n\n  /* Reworked Palette */\n  --primary-font-color: #333333; /* Softer than pure black */\n  --secondary-font-color: #444444; /* For secondary text */\n  --tertiary-font-color: #efefef;\n  --primary-icon-color: #333333; /* Softer black for icons */\n  --primary-header-title-color: #e3e8ed;\n  --editor-heading-font-color: #ffffff;\n  --editor-text-font-color: '#333333';\n\n  --editor-border-color: rgba(5, 5, 5, 0.06);\n  --collapse-button-color: rgb(240, 240, 240);\n  /* --collpsae-button-font-color :  */\n  /* Primary Accent Color */\n  --primary-color: #1890ff; /* Vibrant Purple */\n  --primary-color-hover: #6d28d9; /* Darker purple for hover or active elements */\n  --primary-color-light: #c4b5fd; /* Light Purple for background accents */\n\n  /* Side Navigation Background */\n  --sidemenu-background-color: #f1f5f9; /* Clean, slightly cool light gray */\n  --sidemenu-background-color-hover: rgba(51, 51, 51, 0.06);\n  /* Accent or Success Colors */\n  --highlight-color: #38bdf8; /* For focus/input highlights */\n  --success-color: #34d399; /* Bright green for success icons and messages */\n  --danger-color: #f87171; /* Soft red for warnings/errors */\n\n  /* Text Area Background (outside editor for reference) */\n  --box-background-color: #fafafa; /* Light background for reading areas */\n  --emoji-hover-color: #eee;\n  --sp-color-black: #000000;\n  --sp-color-white: #ffffff;\n  --editor-font-family: 'Inter', sans-serif;\n\n  /* new css variable */\n  /* new themes */\n  --remirror-editor-width: 760px;\n}\n\n::-webkit-scrollbar {\n  height: 1px;\n  width: 5px;\n  background: #d0d0d0;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #8d8d8d; /* White thumb color */\n  border-radius: 10px; /* Rounded corners for the thumb */\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25); /* Shadow effect */\n}\n\n::-webkit-scrollbar-corner {\n  background: #8d8d8d; /* Match thumb color for corner */\n}\n\nbody,\nhtml {\n  margin: 0;\n  padding: 0;\n}\n\nhtml,\nbody,\n#root {\n  width: 100%;\n  height: 100%;\n  min-height: 100vh;\n  max-height: 100vh;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  transition:\n    background-color 0.3s ease,\n    color 0.3s ease;\n}\n\nbody {\n  font-family: 'Inter', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--editor-heading-font-color);\n  cursor: default;\n  background-color: var(--cms-color-bg-container);\n}\n\n.home-layout,\n.settings-layout {\n  display: flex;\n  height: 100%;\n  max-height: 100vh;\n  overflow: hidden !important;\n}\n\n.organization-name {\n  font-size: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.sidemenu-wrapper-collapsed {\n  background: var(--sidemenu-background-color);\n}\n\n.notification-icon {\n  font-size: 1rem;\n  cursor: pointer;\n  border-radius: 5px;\n  padding: 2px 8px;\n  margin-left: 4px;\n}\n\n.icon-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.collapse-button-wrapper {\n  font-size: 0.9rem;\n}\n\n/* .button {\n    font-size: 1rem;\n    padding: 5px 10px;\n    cursor: pointer;\n    border: none;\n    border-radius: 5px;\n  }\n   */\n\n.side-menu-search-icon {\n  font-size: 1.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 5px;\n  height: 40px;\n  border-radius: 8px;\n  margin: 0 5px;\n}\n\n.plus-icon {\n  padding: 2px 8px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.plus-icon:hover {\n  background-color: #0d494cab;\n}\n\n.document-icon {\n  font-size: 1.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 5px;\n  height: 40px;\n  border-radius: 8px;\n  margin: 0 5px;\n}\n\n.document-icon:hover {\n  background-color: #0d494cab;\n}\n\n.sidebar-menu-item-wrapper {\n  background: transparent;\n}\n\n.title-input::placeholder {\n  width: fit-content;\n  font-size: 20px;\n  color: #8899a8;\n}\n\n.space-body {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  min-width: 100%;\n  position: relative;\n}\n\n.space-body .flex-1 {\n  flex: 1;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.layout-component {\n  width: 83%;\n  overflow-y: auto;\n}\n\n@media (max-width: 768px) {\n  .space-sidebar-menu-wrapper {\n    display: none !important;\n  }\n  .space-header {\n    display: none !important;\n  }\n  .settings-sider {\n    overflow-x: hidden;\n    display: none !important;\n  }\n  .flex-row {\n    display: block !important;\n  }\n  .swagger-ui .opblock-tag {\n    display: block;\n  }\n  .space-editor {\n    max-height: calc(100vh - 116px) !important;\n  }\n}\n.space-editor {\n  position: relative;\n  flex: 1;\n  max-height: calc(100vh - 116px);\n  width: 100% !important;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.space-sidebar-menu-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-width: var(--sidebar-full-width);\n  max-width: var(--sidebar-full-width);\n  flex: 1;\n  border-right: 2px solid var(--editor-border-color);\n  overflow-x: auto;\n  overflow-y: hidden;\n  transition: all 0.3s ease;\n  opacity: 1;\n  /* will-change: width; */\n}\n\n.option-button {\n  min-width: 24px !important;\n  max-width: 24px !important;\n  min-height: 24px !important;\n  max-height: 24px !important;\n  display: none !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  justify-content: center !important;\n  opacity: 0;\n  transition: opacity 0.5s ease-in-out;\n}\n.watching-icon {\n  color: #0052cc;\n}\n\n.menu-list-folder-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 20px 10px 2px;\n}\n\n.custom-submenu .ant-menu-submenu-arrow {\n  display: none !important;\n}\n\n.ant-popover-inner {\n  background-color: var(--editor-heading-font-color);\n}\n.ant-dropdown .flex-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.flex-centered {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.custom-antmenu {\n  overflow: auto !important;\n}\n\n/* .user-space-plus-icon-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  padding: 7px 0;\n  border-radius: 8px;\n  font-size: 15px;\n  margin-right: 5px;\n  background-color: rgba(0, 0, 0, 0.05);\n  gap: 10px;\n} */\n\n.user-space-plus-icon-wrapper:hover {\n  background-color: rgba(0, 0, 0, 0.15);\n}\n\n/* styles for google sign in widget */\n\n.gsi-material-button {\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  -webkit-appearance: none;\n  user-select: none;\n  appearance: none;\n  background-color: WHITE;\n  background-image: none;\n  border: 1px solid #747775;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  color: #1f1f1f;\n  cursor: pointer;\n  font-family: 'Inter', sans-serif !important;\n  font-size: 14px;\n  height: 40px;\n  letter-spacing: 0.25px;\n  outline: none;\n  overflow: hidden;\n  padding: 6px 12px !important;\n  position: relative;\n  text-align: center;\n  -webkit-transition:\n    background-color 0.218s,\n    border-color 0.218s,\n    box-shadow 0.218s;\n  transition:\n    background-color 0.218s,\n    border-color 0.218s,\n    box-shadow 0.218s;\n  vertical-align: middle;\n  white-space: nowrap;\n  width: auto;\n  max-width: 400px;\n  min-width: min-content;\n}\n\n.gsi-material-button .gsi-material-button-icon {\n  height: 20px;\n  margin-right: 12px;\n  min-width: 20px;\n  width: 20px;\n}\n\n.gsi-material-button .gsi-material-button-content-wrapper {\n  -webkit-align-items: center;\n  align-items: center;\n  display: flex;\n  -webkit-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  height: 100%;\n  justify-content: center !important;\n  position: relative;\n  width: 100%;\n}\n\n.gsi-material-button .gsi-material-button-state {\n  -webkit-transition: opacity 0.218s;\n  transition: opacity 0.218s;\n  bottom: 0;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.gsi-material-button:disabled {\n  cursor: default;\n  background-color: #ffffff61;\n  border-color: #1f1f1f1f;\n}\n\n.gsi-material-button:disabled .gsi-material-button-contents {\n  opacity: 38%;\n}\n\n.gsi-material-button:disabled .gsi-material-button-icon {\n  opacity: 38%;\n}\n\n.gsi-material-button:not(:disabled):active .gsi-material-button-state,\n.gsi-material-button:not(:disabled):focus .gsi-material-button-state {\n  background-color: #303030;\n  opacity: 12%;\n}\n\n.gsi-material-button:not(:disabled):hover {\n  -webkit-box-shadow:\n    0 1px 2px 0 rgba(60, 64, 67, 0.3),\n    0 1px 3px 1px rgba(60, 64, 67, 0.15);\n  box-shadow:\n    0 1px 2px 0 rgba(60, 64, 67, 0.3),\n    0 1px 3px 1px rgba(60, 64, 67, 0.15);\n}\n\n.gsi-material-button:not(:disabled):hover .gsi-material-button-state {\n  background-color: #303030;\n  opacity: 8%;\n}\n\n/* login page styles */\n\n.login-container {\n  align-items: center;\n  background-color: #fff;\n  border-radius: 0.75rem;\n  display: flex;\n  justify-content: center;\n  left: 50%;\n  overflow: hidden;\n  padding: 6rem 1rem 4rem;\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  width: min(100%, 1140px);\n}\n\n.svg-container {\n  transform: translate(-110px, 10px);\n}\n\n.image-container {\n  display: flex;\n  align-items: center;\n  width: 50%;\n}\n\n.login-container h1 {\n  text-align: center;\n  margin-bottom: 2px;\n}\n\n.login-container h2 {\n  text-align: center;\n  margin-bottom: 2px;\n}\n\n.login-container h3 {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.login-container label {\n  margin-bottom: 8px;\n}\n\n@media (max-width: 767px) {\n  .login-container {\n    align-items: center;\n    background-color: #fff;\n    border-radius: 0.75rem;\n    display: flex;\n    justify-content: center;\n    left: 50%;\n    overflow: hidden;\n    padding: 6rem 1rem 4rem;\n    position: absolute;\n    text-align: center;\n    top: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    width: 80%;\n  }\n  .image-container {\n    display: none;\n  }\n  .login-logos {\n    flex-direction: column;\n  }\n  .file-setting-button {\n    display: none;\n  }\n  .menu-back-button {\n    display: block !important;\n  }\n}\n.menu-back-button {\n  display: none;\n}\n/* Admin layout styles */\n\n.admin-layout-header {\n  background-color: var(--sidemenu-background-color);\n}\n\n/* organization page styles */\n\n.orgnization-component-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  min-height: 100vh;\n}\n.back-button {\n  display: none;\n}\n.organization-second-wrappper {\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  padding: 20px;\n  min-width: 50%;\n}\n\n.organization-title {\n  text-align: center;\n  padding: 20px 0px;\n  font-weight: 500;\n  font-size: 25px;\n}\n\n.organization-form-wrapper {\n  margin: 30px 0px;\n}\n\n.radio-container {\n  text-align: center;\n}\n\n/* integrations page styles */\n\n.integration-page-wrapper {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n  padding: 20px 40px;\n}\n\n.integration-title {\n  margin: 3rem 0px;\n  font-size: 20px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.card-wrapper {\n  min-height: 16vh;\n  width: 17%;\n  transition: transform 0.3s ease;\n  box-shadow:\n    0px 1px 2px 0px rgba(0, 0, 0, 0.15),\n    0px -1px 1px 0px rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n}\n\n.card-wrapper .card-inner-wrapper {\n  font-family: 'Inter', sans-serif;\n  font-size: 15px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.card-wrapper .card-inner-wrapper .auth-success-chip {\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  background-color: rgba(0, 255, 0, 0.2);\n\n  padding: 4px 12px;\n  border-radius: 8px;\n  cursor: default;\n  align-self: flex-start;\n  justify-self: flex-end;\n}\n\n.card-wrapper:hover {\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.integration-cards-container {\n  display: flex;\n  justify-content: flex-start;\n  gap: 4rem;\n}\n\n.org-list-wrapper {\n  min-height: 100vh;\n}\n\n.org-form-wrapper {\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);\n  width: 30%;\n  min-height: 200px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.org-title {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.org-select-wrapper {\n  margin: 30px auto;\n  width: 100%;\n}\n\n.bitbucket_form_wrapper {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n}\n\n.bitbucket_workspace_form_wrapper {\n  padding: 2rem;\n  width: 100%;\n  min-width: 300px;\n  max-width: 600px;\n  box-shadow:\n    rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,\n    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;\n}\n\n.bitbucket_workspace_form_wrapper > .bitbucket_workspace_form {\n  width: 100%;\n}\n\n.bitbucket_form_control .field_label {\n  display: block;\n  font-size: 1rem;\n  font-weight: 600;\n  padding: 0 0 0.25rem;\n}\n\n.user-email-userspace > span:first-child {\n  display: inline-block;\n  font-size: 15px;\n  line-height: 15px;\n  font-weight: 500;\n}\n\n.space-sidebar-menu-wrapper .ant-tree-treenode:hover .option-button,\n.documentation-tab-wrapper + .ant-menu .ant-menu-item:hover .option-button {\n  display: block;\n}\n\n.generic.modal-body .modal-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0px !important;\n  gap: 1rem;\n  margin-right: 2rem;\n  /* padding-bottom: 1rem; */\n}\n\n.generic.modal-body .modal-content {\n  padding-top: 0.25rem;\n  padding-bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.5rem;\n}\n\n.generic.modal-body .preview.modal-header {\n  margin: 0px !important;\n}\n\n.preview.generic .modal-header-wrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px 16px 24px;\n}\n\n.preview.generic .modal-header-wrapper .modal-header-actions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.preview.generic .remirror-editor-wrapper {\n  margin-left: 0;\n  padding: 0;\n}\n\n.move-file-input {\n  border: 0.5px var(--primary-color);\n}\n\n.workspace.one-doc-skeleton {\n  margin: 16px 5px;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.items-center {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.ant-tree-list .ant-tree-node-content-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.5rem;\n  padding-inline: unset !important;\n}\n\n.flex-box {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.ant-tree-list .ant-tree-title {\n  width: 100%;\n  padding: 4px 0;\n}\n\n.ant-tree-list .ant-tree-treenode .ant-tree-draggable-icon {\n  display: none;\n}\n\n.space-breadcrumb {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.access-role-page#access-role-page {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.access-form-wrapper {\n  width: 100%;\n  max-width: 550px;\n}\n\n.access-role-form .form-group {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 1rem;\n}\n\n:where(.json-editor-wrapper.overflow-hidden) {\n  height: calc(100vh - 110px);\n  overflow-y: hidden;\n}\n\n:where(.overflow-auto) {\n  height: 100%;\n  overflow-y: auto;\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n\n:where(.json-editor-wrapper > .overflow-auto)::-webkit-scrollbar {\n  display: none;\n}\n\n:where(.settings-sidebar) {\n  max-width: 300px;\n  width: 100%;\n}\n\n.settings-layout {\n  user-select: none;\n  cursor: default;\n}\n\n.settings-layout .organization-wrapper {\n  margin-bottom: 1rem;\n}\n\n.settings-layout .organization-name {\n  font-size: 1.5rem;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.sidebar-menus .sidebar-menus-title {\n  font-size: 1rem;\n  font-weight: 500;\n  padding: 8px;\n  cursor: default;\n}\n\n:where(.css-dev-only-do-not-override-m4timi).ant-menu-light.ant-menu-root.ant-menu-vertical {\n  border: none;\n  border-inline-end: none;\n  background-color: transparent;\n}\n.user-dialog-wrapper {\n  margin-left: auto;\n}\n\n.sub-setting-page {\n  padding: 1rem 2rem;\n  width: 100%;\n  height: 100%;\n}\n\n.sub-setting-page .sub-setting-header {\n  text-transform: capitalize;\n  font-size: 1rem;\n  font-weight: 500;\n  padding: 0.5rem 2rem;\n  background-color: #eee;\n}\n\n.sub-setting-page .sub-setting-content-wrapper {\n  border: 1px solid #eee;\n  padding: 1rem 2rem;\n  box-shadow:\n    0 4px 6px -1px rgb(0 0 0 / 0.1),\n    0 2px 4px -2px rgb(0 0 0 / 0.1);\n  margin-bottom: 1rem;\n}\n\n.sub-setting-content-wrapper .sub-setting-subtitle {\n  padding: 0.125rem 0.5rem;\n  background-color: #f1f1f1;\n  margin-bottom: 0.5rem;\n}\n\n:where(.css-dev-only-do-not-override-m4timi).ant-menu {\n  font-size: 16px !important;\n}\n\n.sub-setting-subcontent {\n  width: 100%;\n  margin-top: 1rem;\n  padding: 0 2rem;\n}\n\n:where(.sub-setting-subcontent).flex-center {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.organization-name {\n  color: #fff;\n}\n\n.menu-items-spinner-wrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n  padding-top: 2rem;\n}\n\n/* span.ant-tree-node-content-wrapper.ant-tree-node-content-wrapper-normal.ant-tree-node-selected span svg {\n  fill: #fff !important;\n} */\n\n.user-space-plus-icon-wrapper {\n  background: var(--primary-color);\n  color: #fff !important;\n}\n*/ .user-space-plus-icon-wrapper {\n  background: var(--primary-color);\n  color: #fff !important;\n  margin: 10px;\n}\n*/ .button:hover span {\n  color: #fff !important;\n}\n\n.sidebar-menu-items {\n  overflow-y: auto !important;\n}\n\n.space-header .space-title input.title-input {\n  min-width: 100%;\n  border: none;\n  line-height: 32px;\n  font-family: 'Inter', sans-serif;\n  font-weight: 500;\n  margin: 5px 0;\n  background-color: var(--primary-header-title-color);\n  font-size: 20px !important;\n}\n\n.space-header .space-title input::placeholder {\n  color: #fff !important;\n  font-family: 'Inter', sans-serif;\n  font-size: 20px !important;\n  font-weight: 500;\n}\n.delete-icon.anticon svg {\n  fill: #ff0000 !important;\n}\n\n.generic.modal-body .modal-header {\n  flex-direction: row;\n  justify-content: start !important;\n}\n\nform#adam-upload-form {\n  margin-top: 24px;\n}\n\nform#adam-upload-form div label {\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--primary-color) !important;\n}\n\n.sidebar-menus .sidebar-menus-title div {\n  color: #fff !important;\n}\n\n.settings-layout .organization-name {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.settings-layout .organization-name div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.span-12 {\n  width: 120px !important;\n}\n\n.sub-setting-content-wrapper .sub-setting-subtitle {\n  background: var(--primary-color) !important;\n  color: #fff !important;\n}\n\n.sub-setting-page .sub-setting-header {\n  background: var(--primary-color) !important;\n  color: #fff;\n}\n\n.sub-setting-content-wrapper .sub-setting-subtitle {\n  background: var(--primary-color) !important;\n  color: #fff !important;\n}\n\n.bitbucket-page {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n  min-height: 100%;\n  margin: 0;\n  padding: 16px;\n  padding-top: 96px;\n  position: relative;\n  height: 100vh;\n  width: 100%;\n}\n\n.bitbucket-page::before {\n  background: linear-gradient(0deg, rgba(255, 180, 0, 0.5) 0, rgba(255, 180, 0, 0) 100%);\n  content: '';\n  height: 100vh;\n  left: 50%;\n  position: fixed;\n  transform: translateX(-50%) translateY(50%);\n  width: 100%;\n  z-index: -1;\n}\n\n.card-third-party {\n  max-width: 450px;\n  width: 100%;\n  background: #ffffff;\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.04),\n    0 4px 16px -4px rgba(0, 0, 0, 0.16);\n  border-radius: 8px;\n  padding: 32px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\nh1.card-title-third-party {\n  font-size: 23px;\n  text-transform: capitalize;\n  text-align: center;\n  font-weight: 600;\n}\n\n.card-content-third-party p {\n  font-size: 14px;\n  color: #000;\n}\n\n.card-content-third-party p:nth-child(2) {\n  font-size: 12px;\n}\n\n.card-content-third-party a {\n  text-decoration: none;\n  font-weight: 400;\n  font-size: 12px;\n}\n\n.count-down-wrapper {\n  background-color: rgba(255, 180, 0, 0.5);\n  height: 30px;\n  width: 30px;\n  border-radius: 25px;\n  transition-duration: 4s;\n  transition-property: background-color;\n  animation-name: grow;\n  animation-duration: 9s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  -webkit-transition-property: -webkit-transform background-color;\n  -webkit-transition-duration: 4s;\n  -moz-transition-property: -moz-transform background-color;\n  -moz-transition-duration: 4s;\n  -webkit-animation-name: grow;\n  -webkit-animation-duration: 9s;\n  -webkit-animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n  -moz-animation-name: grow;\n  -moz-animation-duration: 9s;\n  -moz-animation-iteration-count: infinite;\n  -moz-animation-timing-function: linear;\n}\n\n@keyframes grow {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.5);\n    background-color: red;\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\np.count-down-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\nspan.count-down,\np.count-down {\n  font-size: 16px;\n  font-weight: 500;\n  color: #fff;\n}\n\n.card-content-third-party {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n:where(.css-dev-only-do-not-override-m4timi).upload-modal.small {\n  width: unset !important;\n  min-width: 520px !important;\n  max-width: 520px !important;\n}\n\n:where(.css-dev-only-do-not-override-m4timi).upload-modal.large {\n  width: unset !important;\n  min-width: 520px !important;\n  max-width: 900px !important;\n}\n\n.para-link {\n  text-align: center;\n  width: 83%;\n}\n\n.integration-page-wrapper {\n  max-width: calc(980px + 8rem) !important;\n  margin: 0 auto;\n  padding-left: 6rem;\n  padding-right: 6rem;\n}\n\n.integration-title {\n  text-align: left;\n  margin: 0;\n}\n.integration-img-wrapper {\n  width: 50%;\n}\n.int-img {\n  width: -moz-available;\n  border-radius: 10px !important;\n}\n.integration-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 4rem;\n}\n\n*:not('.space-editor') {\n  margin: 0;\n  padding: 0;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n/* :root {\n    --sidemenu-background-color: var(--primary-color);\n    --hover-background-color: #019299ab;\n  } */\n\n::-webkit-scrollbar {\n  height: 1px;\n  width: 5px;\n  background: #d0d0d0;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #8d8d8d; /* White thumb color */\n  border-radius: 10px; /* Rounded corners for the thumb */\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25); /* Shadow effect */\n}\n\n::-webkit-scrollbar-corner {\n  background: #8d8d8d; /* Match thumb color for corner */\n}\n\nbody,\nhtml {\n  margin: 0;\n  padding: 0;\n}\n\nhtml,\nbody,\n#root {\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n}\n\nbody {\n  font-family: 'Inter', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.organization-name {\n  font-size: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.organization-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 10px 10px 10px 0 !important;\n}\n\n.organization-wrapper-collapsed {\n  padding: 2px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 5px 0;\n}\n\n.sidemenu-wrapper {\n  min-width: 270px;\n  max-width: 270px;\n  width: 17%;\n  padding: 0 10px;\n  background: var(--sidemenu-background-color);\n  border-right: 1px solid rgb(227, 232, 237);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-start;\n}\n@media (max-width: 768px) {\n  /* Adjust this breakpoint as necessary */\n  .sidemenu-wrapper {\n    display: none; /* Hide on mobile */\n  }\n  .sidemenu-wrapper-collapsed {\n    display: none;\n  }\n  .space-breadcumb {\n    display: none;\n  }\n}\n\n.sidemenu-wrapper-collapsed {\n  background-color: var(--sidemenu-background-color);\n}\n\n.notification-icon {\n  font-size: 1rem;\n  cursor: pointer;\n  border-radius: 5px;\n  padding: 2px 8px;\n}\n\n.notification-icon:hover {\n  background-color: var(--sidemenu-background-color-hover);\n  color: var(--primary-color);\n}\n\n.bell-icon:hover {\n  color: var(--primary-color) !important;\n}\n.icon-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.collapse-button-wrapper {\n  font-size: 0.9rem;\n}\n\n.button {\n  font-size: 1rem;\n  padding: 5px 10px;\n  cursor: pointer;\n  border: none;\n  border-radius: 5px;\n  background-color: var(--sidemenu-background-color);\n  color: var(--editor-heading-font-color);\n}\n\n.side-menu-search-icon {\n  font-size: 1.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 5px;\n  height: 40px;\n  border-radius: 8px;\n  margin: 0 5px;\n}\n\n.documentation-tab-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0.5rem;\n  font-size: 16px;\n}\n\n.plus-icon {\n  padding: 2px 8px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.plus-icon:hover {\n  background-color: #0d494cab;\n}\n\n.document-icon {\n  font-size: 1.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 5px;\n  height: 40px;\n  border-radius: 8px;\n  margin: 0 5px;\n}\n\n.document-icon:hover {\n  background-color: var(--sidemenu-background-color-hover);\n  color: var(--primary-color);\n}\n\n.sidebar-menu-items {\n  background-color: var(--sidemenu-background-color);\n  border: none !important;\n  margin: 10px 0px;\n}\n\n.space-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\n\n.space-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 60px;\n  font-size: 1.5rem;\n  border-bottom: 1px solid rgb(227, 232, 237);\n  padding-right: 8px;\n}\n\n.space-title {\n  padding: 0 20px;\n  width: 35%;\n  max-width: 540px;\n}\n\n.title-input:hover {\n  background-color: rgb(227, 232, 237);\n}\n\n.title-input:focus {\n  background-color: rgb(227, 232, 237);\n  outline: none;\n}\n\n.space-sub-header {\n  height: 50px;\n  border-bottom: 1px solid rgb(227, 232, 237);\n  padding: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  padding-left: 20px !important;\n}\n\n.space-body {\n  display: flex;\n  height: 100%;\n  position: relative;\n}\n\n.layout-component {\n  width: 83%;\n  overflow-y: auto;\n}\n\n/* .space-editor {\n      min-width: 85%;\n      overflow-x: auto;\n      overflow-y: auto;\n  } */\n.tree-wrapper {\n  height: 100%;\n  max-height: calc(100vh - 172px);\n  overflow-y: auto;\n}\n\n.menu-list-folder-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 20px 10px 2px;\n}\n\n.custom-submenu .ant-menu-submenu-arrow {\n  display: none !important;\n}\n\n.flex-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.flex-centered {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.custom-antmenu {\n  overflow: auto !important;\n}\n\n/* .user-space-plus-icon-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  padding: 7px 0;\n  border-radius: 8px;\n  font-size: 15px;\n  margin-right: 5px;\n  background-color: rgba(0, 0, 0, 0.05);\n  gap: 10px;\n} */\n\n/* .user-space-plus-icon-wrapper:hover {\n  background-color: rgba(0, 0, 0, 0.15);\n} */\n\n/* styles for google sign in widget */\n\n.gsi-material-button {\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  -webkit-appearance: none;\n  user-select: none;\n  appearance: none;\n  background-color: WHITE;\n  background-image: none;\n  border: 1px solid #747775;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  color: #1f1f1f;\n  cursor: pointer;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  height: 40px;\n  letter-spacing: 0.25px;\n  outline: none;\n  overflow: hidden;\n  padding: 0 12px;\n  position: relative;\n  text-align: center;\n  -webkit-transition:\n    background-color 0.218s,\n    border-color 0.218s,\n    box-shadow 0.218s;\n  transition:\n    background-color 0.218s,\n    border-color 0.218s,\n    box-shadow 0.218s;\n  vertical-align: middle;\n  white-space: nowrap;\n  width: auto;\n  max-width: 400px;\n  min-width: min-content;\n}\n\n.gsi-material-button .gsi-material-button-icon {\n  height: 20px;\n  margin-right: 12px;\n  min-width: 20px;\n  width: 20px;\n}\n\n.gsi-material-button .gsi-material-button-content-wrapper {\n  -webkit-align-items: center;\n  align-items: center;\n  display: flex;\n  -webkit-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  height: 100%;\n  justify-content: space-between;\n  position: relative;\n  width: 100%;\n}\n\n.gsi-material-button .gsi-material-button-contents {\n  font-family: 'Inter', sans-serif;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  vertical-align: top;\n}\n\n.gsi-material-button .gsi-material-button-state {\n  -webkit-transition: opacity 0.218s;\n  transition: opacity 0.218s;\n  bottom: 0;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.gsi-material-button:disabled {\n  cursor: default;\n  background-color: #ffffff61;\n  border-color: #1f1f1f1f;\n}\n\n.gsi-material-button:disabled .gsi-material-button-contents {\n  opacity: 38%;\n}\n\n.gsi-material-button:disabled .gsi-material-button-icon {\n  opacity: 38%;\n}\n\n.gsi-material-button:not(:disabled):active .gsi-material-button-state,\n.gsi-material-button:not(:disabled):focus .gsi-material-button-state {\n  background-color: #303030;\n  opacity: 12%;\n}\n\n.gsi-material-button:not(:disabled):hover {\n  -webkit-box-shadow:\n    0 1px 2px 0 rgba(60, 64, 67, 0.3),\n    0 1px 3px 1px rgba(60, 64, 67, 0.15);\n  box-shadow:\n    0 1px 2px 0 rgba(60, 64, 67, 0.3),\n    0 1px 3px 1px rgba(60, 64, 67, 0.15);\n}\n\n.gsi-material-button:not(:disabled):hover .gsi-material-button-state {\n  background-color: #303030;\n  opacity: 8%;\n}\n.gsi-material-button:hover {\n  background: white !important;\n}\n/* login page styles */\n\n.login-container {\n  align-items: center;\n  background-color: #fff;\n  border-radius: 0.75rem;\n  display: flex;\n  justify-content: center;\n  left: 50%;\n  overflow: hidden;\n  padding: 6rem 1rem 4rem;\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  width: min(100%, 1140px);\n}\n\n.svg-container {\n  transform: translate(-110px, 10px);\n}\n\n.image-container {\n  display: flex;\n  align-items: center;\n  width: 50%;\n}\n\n.login-container h1 {\n  text-align: center;\n  margin-bottom: 2px;\n}\n\n.login-container h2 {\n  text-align: center;\n  margin-bottom: 2px;\n}\n\n.login-container h3 {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.login-container label {\n  margin-bottom: 8px;\n}\n\n.login-container input {\n  padding: 10px;\n  margin-bottom: 15px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  font-size: 16px;\n  width: 100%;\n}\n\n.login-container input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  color: #000000 !important;\n  background-color: whitesmoke !important;\n  background: whitesmoke !important;\n}\n\n@media (max-width: 767px) {\n  .login-container {\n    align-items: center;\n    background-color: #fff;\n    border-radius: 0.75rem;\n    display: flex;\n    justify-content: center;\n    left: 50%;\n    overflow: hidden;\n    padding: 6rem 1rem 4rem;\n    position: absolute;\n    text-align: center;\n    top: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    width: 80%;\n  }\n  .image-container {\n    display: none;\n  }\n  .login-logos {\n    flex-direction: column;\n  }\n}\n\n/* Admin layout styles */\n\n.admin-layout-header {\n  background-color: var(--sidemenu-background-color);\n}\n\n/* organization page styles */\n\n.orgnization-component-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  min-height: 100vh;\n}\n\n.organization-second-wrappper {\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  padding: 20px;\n  min-width: 50%;\n}\n\n.organization-title {\n  text-align: center;\n  padding: 20px 0px;\n  font-weight: 500;\n  font-size: 25px;\n  color: var(--primary-color);\n}\n\n.organization-form-wrapper {\n  margin: 30px 0px;\n}\n\n.radio-container {\n  text-align: center;\n}\n\n/* integrations page styles */\n\n.integration-page-wrapper {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n  padding: 20px 40px;\n}\n\n.integration-title {\n  margin: 0;\n  font-size: 32px;\n  font-weight: 500;\n  text-align: left;\n}\n\n.card-wrapper {\n  min-height: 16vh;\n  width: 17%;\n  transition: transform 0.3s ease;\n  box-shadow:\n    0px 1px 2px 0px rgba(0, 0, 0, 0.15),\n    0px -1px 1px 0px rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n}\n\n.card-wrapper:hover {\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.integration-cards-container {\n  display: flex;\n  justify-content: flex-start;\n  gap: 4rem;\n}\n\n.org-list-wrapper {\n  min-height: 100vh;\n}\n\n.org-form-wrapper {\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);\n  width: 30%;\n  min-height: 200px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.org-title {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.org-select-wrapper {\n  margin: 30px auto;\n  width: 100%;\n}\n\n.bitbucket_form_wrapper {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n}\n\n.bitbucket_workspace_form_wrapper {\n  padding: 2rem;\n  width: 100%;\n  min-width: 300px;\n  max-width: 600px;\n  box-shadow:\n    rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,\n    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;\n}\n\n.bitbucket_workspace_form_wrapper > .bitbucket_workspace_form {\n  width: 100%;\n}\n\n.bitbucket_form_control .field_label {\n  display: block;\n  font-size: 1rem;\n  font-weight: 600;\n  padding: 0 0 0.25rem;\n}\n\n.user-email-userspace > span:first-child {\n  display: inline-block;\n  font-size: 15px;\n  line-height: 15px;\n  font-weight: 500;\n}\n\n.space-sidebar-menu-wrapper .ant-tree-treenode:hover .option-button {\n  display: flex !important;\n  opacity: 1 !important;\n}\n.space-sidebar-menu-wrapper .ant-tree-treenode .option-button {\n  display: flex !important;\n}\n\n.generic.modal-body .modal-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 1rem;\n  margin-right: 2rem;\n  padding-bottom: 1rem;\n}\n\n.generic.modal-body .modal-content {\n  padding-top: 0.25rem;\n  padding-bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.5rem;\n}\n\n.generic.modal-body .preview.modal-header {\n  margin: 0px !important;\n}\n\n.preview.generic .modal-header-wrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.preview.generic .modal-header-wrapper .modal-header-actions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.preview.generic .remirror-editor-wrapper {\n  margin-left: 0;\n  padding: 0;\n}\n\n.ant-modal.template .modal-template-card {\n  display: flex;\n  min-height: 46px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  font-size: 16px;\n  font-weight: 400;\n  padding: 4px 0;\n  cursor: pointer;\n  border-bottom: 1px solid #dbdbdb;\n}\n\n.workspace.one-doc-skeleton {\n  margin: 16px 5px;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.items-center {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-box {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.space-breadcrumb {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.access-role-page#access-role-page {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.access-form-wrapper {\n  width: 100%;\n  max-width: 550px;\n}\n\n.access-role-form .form-group {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 1rem;\n}\n\n:where(.json-editor-wrapper.overflow-hidden) {\n  height: calc(100vh - 110px);\n  overflow-y: hidden;\n}\n\n:where(.overflow-auto) {\n  height: 100%;\n  overflow-y: auto;\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n\n:where(.json-editor-wrapper > .overflow-auto)::-webkit-scrollbar {\n  display: none;\n}\n\n:where(.settings-sidebar) {\n  max-width: 300px;\n  width: 100%;\n}\n\n.settings-layout {\n  user-select: none;\n  cursor: default;\n}\n\n.settings-layout .organization-wrapper {\n  margin-bottom: 1rem;\n}\n\n.settings-layout .organization-name {\n  font-size: 1.5rem;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.sidebar-menus .sidebar-menus-title {\n  font-size: 1rem;\n  font-weight: 500;\n  padding: 8px;\n  cursor: default;\n}\n\n.user-dialog-wrapper {\n  margin-left: auto;\n}\n\n.sub-setting-page {\n  padding: 1rem 2rem;\n  width: 100%;\n  height: 100%;\n}\n\n.sub-setting-page .sub-setting-header {\n  text-transform: capitalize;\n  font-size: 1rem;\n  font-weight: 500;\n  padding: 0.5rem 2rem;\n  background-color: #eee;\n}\n\n.sub-setting-page .sub-setting-content-wrapper {\n  border: 1px solid #eee;\n  padding: 1rem 2rem;\n  box-shadow:\n    0 4px 6px -1px rgb(0 0 0 / 0.1),\n    0 2px 4px -2px rgb(0 0 0 / 0.1);\n  margin-bottom: 1rem;\n}\n\n.sub-setting-content-wrapper .sub-setting-subtitle {\n  padding: 0.125rem 0.5rem;\n  background-color: #f1f1f1;\n  margin-bottom: 0.5rem;\n}\n\n.sub-setting-subcontent {\n  width: 100%;\n  margin-top: 1rem;\n  padding: 0 2rem;\n}\n\n:where(.sub-setting-subcontent).flex-center {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.documentation-tab-wrapper {\n  color: var(--editor-heading-font-color) !important;\n}\n\n.organization-name {\n  color: var(--primary-font-color);\n}\n\n.side-menu-search-icon:hover {\n  background-color: var(--sidemenu-background-color-hover);\n  color: var(--primary-color) !important;\n}\n\n.menu-items-spinner-wrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n  padding-top: 2rem;\n}\n\n.space-sidebar-menu-wrapper {\n  font-size: 16px !important;\n}\n\n.user-space-plus-icon-wrapper {\n  background: var(--primary-color);\n  color: #fff !important;\n}\n\n.button:hover span {\n  color: #fff !important;\n}\n\n.button:hover span {\n  color: var(--primary-color) !important;\n}\n\n.space-header {\n  background-color: var(--sidemenu-background-color);\n}\n\n.sidebar-menu-items {\n  overflow-y: auto !important;\n}\n\n.user-space-plus-icon-wrapper .add-button {\n  border: none !important;\n  outline: none !important;\n}\n\n.user-space-plus-icon-wrapper .add-button:hover {\n  border: none !important;\n}\n.user-space-plus-icon-wrapper {\n  flex-direction: row-reverse;\n  border: none;\n  font-weight: 600;\n}\n\n.side-menu-search-box {\n  margin: 20px 0 10px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.space-header .space-title input {\n  margin: 5px 0;\n  border: 1px solid var(--primary-color);\n}\n\n.generic.modal-title {\n  font-size: 16px;\n  font-weight: 500;\n  padding: 16px 24px 16px 24px;\n}\n\n.generic.modal-icon svg {\n  fill: var(--primary-color);\n}\n\n.remirror-theme {\n  width: 100%;\n}\n\n.remirror-editor.ProseMirror {\n  overflow-y: auto !important;\n}\n\nform#adam-upload-form {\n  margin-top: 24px;\n}\n\nform#adam-upload-form div label {\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--primary-color) !important;\n}\n\n.sidebar-menus .sidebar-menus-title div {\n  color: #fff !important;\n}\n\n.settings-layout .organization-name {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.settings-layout .organization-name div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.span-12 {\n  width: 120px !important;\n}\n\n.sub-setting-content-wrapper .sub-setting-subtitle {\n  background: var(--primary-color) !important;\n  color: #fff !important;\n}\n\n.sub-setting-page .sub-setting-header {\n  background: var(--primary-color) !important;\n  color: #fff;\n}\n\n.sub-setting-content-wrapper .sub-setting-subtitle {\n  background: var(--primary-color) !important;\n  color: #fff !important;\n}\n\n.bitbucket-page {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n  min-height: 100%;\n  margin: 0;\n  padding: 16px;\n  padding-top: 96px;\n  position: relative;\n  height: 100vh;\n  width: 100%;\n}\n\n.bitbucket-page::before {\n  background: linear-gradient(0deg, rgba(255, 180, 0, 0.5) 0, rgba(255, 180, 0, 0) 100%);\n  content: '';\n  height: 100vh;\n  left: 50%;\n  position: fixed;\n  transform: translateX(-50%) translateY(50%);\n  width: 100%;\n  z-index: -1;\n}\n\n.card-third-party {\n  max-width: 450px;\n  width: 100%;\n  background: #ffffff;\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.04),\n    0 4px 16px -4px rgba(0, 0, 0, 0.16);\n  border-radius: 8px;\n  padding: 32px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\nh1.card-title-third-party {\n  font-size: 23px;\n  text-transform: capitalize;\n  text-align: center;\n  font-weight: 600;\n}\n\n.card-content-third-party p {\n  font-size: 14px;\n  color: #000;\n}\n\n.card-content-third-party p:nth-child(2) {\n  font-size: 12px;\n}\n\n.card-content-third-party a {\n  text-decoration: none;\n  font-weight: 400;\n  font-size: 12px;\n}\n\n.count-down-wrapper {\n  background-color: rgba(255, 180, 0, 0.5);\n  height: 30px;\n  width: 30px;\n  border-radius: 25px;\n  transition-duration: 4s;\n  transition-property: background-color;\n  animation-name: grow;\n  animation-duration: 9s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  -webkit-transition-property: -webkit-transform background-color;\n  -webkit-transition-duration: 4s;\n  -moz-transition-property: -moz-transform background-color;\n  -moz-transition-duration: 4s;\n  -webkit-animation-name: grow;\n  -webkit-animation-duration: 9s;\n  -webkit-animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n  -moz-animation-name: grow;\n  -moz-animation-duration: 9s;\n  -moz-animation-iteration-count: infinite;\n  -moz-animation-timing-function: linear;\n}\n\n@keyframes grow {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.5);\n    background-color: red;\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\np.count-down-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\nspan.count-down,\np.count-down {\n  font-size: 16px;\n  font-weight: 500;\n  color: #fff;\n}\n\n.card-content-third-party {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n:where(.css-dev-only-do-not-override-m4timi).upload-modal.small {\n  width: unset !important;\n  min-width: 520px !important;\n  max-width: 520px !important;\n}\n\n:where(.css-dev-only-do-not-override-m4timi).upload-modal.large {\n  width: unset !important;\n  min-width: 520px !important;\n  max-width: 900px !important;\n}\n\n.para-link {\n  text-align: center;\n  width: 83%;\n}\n\n.integration-page-wrapper {\n  max-width: calc(980px + 8rem) !important;\n  padding-left: 6rem !important;\n  padding-right: 6rem !important;\n}\n\n.integration-title {\n  text-align: left;\n  margin: 0;\n}\n.integration-img-wrapper {\n  width: 50%;\n}\n.int-img {\n  width: -moz-available;\n}\n.integration-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 4rem;\n}\n\n.int-img {\n  width: -moz-available;\n  height: 115px;\n  position: relative;\n  top: 22%;\n}\n\n.para-int {\n  margin: 0 auto;\n}\n.inner-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.integration-cards-container {\n  flex-direction: column;\n  gap: 0rem;\n  margin-top: -1rem;\n}\n\n.card-inner-content h2 {\n  font-size: 20px;\n  font-weight: 500;\n  color: var(--editor-heading-font-color);\n}\n\n.integration-cards-container.inter-cards .ant-card {\n  width: 45%;\n  min-height: auto !important;\n}\n\n.integration-cards-container .ant-card .card-inner-wrapper {\n  justify-content: flex-start !important;\n  align-items: flex-start !important;\n  gap: 1rem !important;\n}\n.card-inner-container-content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.integration-cards-container .ant-card.ant-card-bordered.card-wrapper.css-dev-only-do-not-override-f7vrd6 {\n  width: 45%;\n  min-height: auto !important;\n}\n.integration-cards-container .ant-card.ant-card-bordered.card-wrapper .ant-card-body {\n  padding: 16px 16px 0px;\n  border: 1px solid rgba(0, 0, 0, 0);\n}\n.card-inner-para p {\n  margin: 0 !important;\n  color: var(--editor-heading-font-color) !important;\n}\n\n.content-link {\n  color: var(--editor-heading-font-color);\n}\n\n.content-link div:first-child {\n  font-weight: 600;\n}\n\n.sub-text {\n  position: relative;\n  top: -8%;\n}\n\n.card-inner-container-content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  gap: 8px;\n}\n\nh2 {\n  color: #262930;\n}\n\n.integration-cards-container .ant-card {\n  width: 45% !important;\n  height: fit-content;\n}\n\n/* file and workspace settings modal */\n\n.announcement-modal {\n  --modal-content-width: 900px;\n  --modal-content-height: 650px;\n  width: var(--modal-content-width) !important;\n}\n.announcement-modal .ant-modal-content {\n  padding: 0px;\n}\n.template .ant-modal-content {\n  padding: 0px;\n}\n\n.file-setting-modal,\n.workspace-setting-modal {\n  --modal-content-width: 900px;\n  --modal-content-height: 650px;\n  width: var(--modal-content-width) !important;\n}\n\n.file-setting-modal .file-setting-content,\n.workspace-setting-modal .workspace-setting-content {\n  position: relative;\n  overflow: auto;\n  padding-right: 1rem;\n  flex: 1;\n}\n\n.file-setting-modal .file-setting-header,\n.workspace-setting-modal .workspace-setting-header {\n  padding: 1rem;\n  padding-left: 0;\n  margin-bottom: 16px !important;\n  border-bottom: 1px solid #d6d6d6;\n}\n\n.file-setting-modal .file-setting-header h1,\n.workspace-setting-modal .workspace-setting-header h1 {\n  font-family: 'Inter', sans-serif;\n  font-size: 20px;\n  font-weight: 700 !important;\n  margin: 0;\n}\n\n.file-setting-modal .tab-setting-group,\n.workspace-setting-modal .tab-setting-group {\n  margin-bottom: 1rem;\n}\n\n.file-setting-modal .tab-setting-group .tab-setting-header h1,\n.workspace-setting-modal .tab-setting-group .tab-setting-header h1 {\n  font-family: 'Inter', sans-serif;\n  font-size: 18px !important;\n  font-weight: 600;\n  margin: 0;\n}\n\n.workspace-setting-modal .info,\n.file-setting-modal .info {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.workspace-setting-modal .info p,\n.file-setting-modal .info p {\n  margin: 0;\n  font-family: 'Inter', sans-serif;\n}\n\n.workspace-setting-modal .info p.info-header,\n.file-setting-modal .info p.info-header {\n  font-weight: 500;\n}\n\n.setting-item-header {\n  margin-bottom: 6px;\n}\n\n.setting-item-header-content {\n  /* color: var(--editor-text-font-color); */\n  font-family: 'Inter', sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  margin: 0;\n}\n\n.tab-setting-item.flex-row .setting-item-header-content {\n  max-width: 300px;\n  margin-top: 5px;\n}\n\n.tab-setting-item.flex-row .setting-item-header-content.lg {\n  max-width: 500px;\n}\n\n.setting-item-header-content.main {\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.file-rename-content,\n.workspace-rename-content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 1rem;\n}\n\n.file-rename-content input:hover,\n.workspace-rename-content input:hover,\n.login-container input:hover,\n.manage-permission-wrapper input:hover {\n  border-color: #ccc;\n}\n\n.file-rename-content input:focus,\n.workspace-rename-content input:focus,\n.manage-permission-wrapper input:focus {\n  border-color: var(--primary-color);\n  color: var(--editor-heading-font-color);\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.tab-setting-header {\n  margin-bottom: 4px;\n}\n\n.tab-setting-content {\n  padding: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n}\n.tab-setting-content .tab-setting-item {\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 16px;\n  margin-bottom: 16px;\n}\n\n.tab-setting-content .tab-setting-item:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n  margin-bottom: 0;\n}\n\n.file-setting-modal .copy-code-modal .copy-code-modal-header h1 {\n  font-size: 20px;\n  font-family: 'Inter', sans-serif;\n  margin: 0;\n}\n\n.file-setting-modal .copy-code-modal .copy-code-modal-header p {\n  font-size: 16px;\n  font-family: 'Inter', sans-serif;\n  margin: 0;\n}\n\n.file-setting-modal .copy-code-modal .copy-code-modal-header {\n  margin-bottom: 16px;\n}\n\n.copy-code-modal .copy-code-toolbar {\n  border: 1px solid #ddd;\n  padding: 0.25rem 1rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n\n.copy-code-modal .copy-code-toolbar .icon-btn {\n  border: 1px solid #ddd;\n}\n\n.copy-code-modal .copy-code-toolbar .icon-btn svg {\n  fill: #777 !important;\n}\n\n.copy-code-modal .copy-code-modal-content {\n  border: 1px solid #ddd;\n  border-top: 0;\n  width: 100%;\n  overflow: hidden;\n  padding: 0 !important;\n}\n\n.copy-code-modal .copy-code-modal-content pre {\n  width: 100%;\n  margin: 0;\n  padding: 0.5rem 1rem;\n  color: #fff;\n  background-color: rgb(26, 26, 103);\n  overflow: auto;\n}\n\n.tab-setting-item .setting-item-feedback {\n  display: inline-block;\n  padding: 0.25rem 1rem;\n  margin-top: 0.5rem;\n  border-radius: 4px;\n  font-family: 'Inter', sans-serif;\n}\n\n.tab-setting-item .setting-item-feedback.error {\n  color: red;\n  border: 1px solid rgba(255, 0, 0, 1);\n  background-color: rgba(255, 0, 0, 0.1);\n}\n\n.tab-setting-item .setting-item-feedback.success {\n  color: green;\n  border: 1px solid rgba(0, 255, 0, 1);\n  background-color: rgba(0, 255, 0, 0.1);\n}\n\nbutton {\n  align-items: center;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  cursor: pointer;\n  flex-basis: auto;\n  flex-direction: row;\n  flex-grow: 0;\n  flex-shrink: 0;\n  justify-content: center;\n  outline: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  text-decoration-line: none;\n  padding-inline: var(--padding-inline-size, --sp-spacing-300);\n}\n\nbutton:disabled {\n  opacity: 0.7;\n}\n\n.openapi-modal .upload-modal-header h1,\n.openapi-editor .openapi-header h1,\n.copy-code-modal .copy-code-modal-header h1,\n.rename-template .rename-template-header h1,\n.bitbucket-import-template .bitbucket-import-template-header h1,\n.upload-toolbar-modal .upload-toolbar-header h1,\n.onedoc-modal .onedoc-modal-header h1 {\n  font-family: 'Inter', sans-serif;\n  font-size: 24px;\n  margin: 0;\n}\n\n.openapi-modal .upload-modal-header p,\n.openapi-editor .openapi-header p,\n.copy-code-modal .copy-code-modal-header p,\n.rename-template .rename-template-header p,\n.bitbucket-import-template .bitbucket-import-template-header p,\n.upload-toolbar-modal .upload-toolbar-header p,\n.onedoc-modal .onedoc-modal-header p {\n  margin: 0;\n  font-family: 'Inter', sans-serif;\n  font-size: 15px;\n  color: var(--sp-color-text-muted);\n}\n\n.openapi-modal .upload-modal-content,\n.rename-template .rename-template-content,\n.bitbucket-import-template .bitbucket-import-template-content,\n.upload-toolbar-modal .upload-toolbar-content,\n.onedoc-modal .onedoc-modal-content {\n  /* padding: 1rem; */\n  padding-top: 0;\n}\n\n.rename-template .rename-template-content {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n.rename-input-group .iconinput-wrapper {\n  cursor: pointer;\n}\n\n.rename-template .titleinput-wrapper,\n.onedoc-modal .input-wrapper {\n  flex: 1;\n}\n\n.openapi-modal input,\n.rename-template input,\n.upload-toolbar-modal .direct-link-upload-template input,\n.rename-template .iconinput-wrapper,\n.onedoc-modal .input-wrapper input {\n  font-family: 'Inter', sans-serif;\n  font-size: 15px;\n  border-color: rgb(223, 225, 230);\n  /* color: rgb(9, 30, 66); */\n  cursor: text;\n  border-radius: 3px;\n  border-width: 2px;\n  border-style: solid;\n  box-sizing: border-box;\n  transition:\n    background-color 0.2s ease-in-out 0s,\n    border-color 0.2s ease-in-out 0s;\n  line-height: 1.42857;\n  padding: 8px 6px;\n  height: 36px;\n}\n\n.openapi-modal input:focus,\n.rename-template input:focus,\n.upload-toolbar-modal .direct-link-upload-template input:focus,\n.onedoc-modal .input-wrapper input:focus {\n  /* background-color: rgb(255, 255, 255); */\n  border-color: var(--primary-color);\n}\nintegration-info {\n  overflow-y: auto;\n  max-width: 500px;\n}\n\n.openapi-modal .titleinput-wrapper .titleinput-label,\n.rename-template .titleinput-wrapper .titleinput-label,\n.upload-toolbar-modal .direct-link-upload-template .direct-link-label,\n.rename-template .iconinput-label,\n.onedoc-modal .input-label-wrapper .input-label {\n  margin: 0;\n  font-family: 'Inter', sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  margin-bottom: 4px;\n}\n\n.openapi-modal .titleinput-wrapper .titleinput-error,\n.rename-template .titleinput-wrapper .titleinput-error,\n.upload-toolbar-modal .direct-link-error,\n.onedoc-modal .input-wrapper .input-error-wrapper {\n  margin: 0;\n  font-family: 'Inter', sans-serif;\n  font-size: 15px;\n  font-weight: 400;\n  margin-top: 8px;\n  padding: 0.25rem 1rem;\n  color: rgb(255, 0, 0);\n  background-color: rgba(255, 0, 0, 0.1);\n  border-radius: 4px;\n}\n\n.openapi-modal .dropbox-wrapper,\n.upload-toolbar-modal .local-file-upload-template .dropbox-wrapper {\n  margin-top: 12px;\n}\n\n.dropbox-wrapper .dragger-text {\n  padding: 0.5rem 0rem 0;\n  font-size: 15px;\n}\n\n.dropbox-wrapper .dragger-hint {\n  margin-bottom: 0.5rem;\n  font-weight: 400;\n}\n\n.openapi-modal .upload-modal-footer,\n.openapi-editor .openapi-editor-footer,\n.rename-template .rename-template-footer,\n.bitbucket-import-template .bitbucket-import-template-footer,\n.upload-toolbar-modal .upload-toolbar-footer,\n.onedoc-modal .onedoc-modal-footer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 1rem;\n  /* padding: 0 1rem 1rem; */\n  margin-top: 1rem;\n}\n\n.openapi-editor .openapi-content {\n  height: 500px;\n}\n.openapi-modal.large,\n.openapi-modal.large .ant1-modal-content,\n.openapi-modal.large .ant1-modal-body,\n.workspace-modal.large,\n.workspace-modal.large .ant1-modal-content,\n.workspace-modal.large .ant1-modal-body {\n  width: 800px !important;\n}\n\n.onedoc-modal.publish-modal,\n.onedoc-modal.publish-modal .ant1-modal-content,\n.onedoc-modal.publish-modal .ant1-modal-body {\n  width: 600px !important;\n}\n\n.copy-code-modal .copy-code-modal-body {\n  padding: 1rem;\n  padding-top: 0;\n}\n\n.openapi-editor .openapi-content {\n  overflow: hidden;\n}\n\n.openapi-editor .openapi-inner-content {\n  overflow: auto;\n  height: 100%;\n}\n\n.openapi-editor .openapi-editor-error {\n  margin: 0 1rem 1rem;\n  color: rgb(255, 0, 0);\n  background-color: rgba(255, 0, 0, 0.1);\n  font-family: 'Inter', sans-serif;\n  padding: 0.5rem 1.25rem;\n  border-radius: 4px;\n}\n\n.spinner-wrapper,\n.spinner-wrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.spinner-wrapper .anticon svg {\n  fill: var(--sp-color-text-primary) !important;\n}\n\n.settings-tab-group {\n  border: 1px solid var(--sp-color-border-base);\n  margin: 2rem;\n  border-radius: 8px;\n}\n\n.settings-tab-group .settings-tab-header {\n  padding: 1rem;\n  border-bottom: 1px solid var(--sp-color-border-base);\n}\n\n.settings-tab-group .settings-tab-header h1 {\n  font-family: 'Inter', sans-serif;\n  color: var(--editor-heading-font-color);\n  margin: 0;\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.settings-tab-content .settings-tab-item .tab-item-header p {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--editor-heading-font-color);\n}\n\n.settings-tab-content .settings-tab-item {\n  padding: 1rem;\n  border-bottom: 1px solid var(--sp-color-border-base);\n}\n\n.settings-tab-content .settings-tab-item:last-child {\n  border-bottom: none;\n}\n\n.settings-tab-content .settings-tab-item .tab-item-content p {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.workspace-settings-page {\n  margin: 2rem;\n  border-radius: 8px;\n  border: 1px solid var(--sp-color-border-base);\n}\n\n.workspace-settings-page .workspace-settings-header {\n  padding: 1rem;\n  border-bottom: 1px solid var(--sp-color-border-base);\n}\n\n.workspace-settings-page .workspace-settings-header h1 {\n  margin: 0;\n  font-size: 20px;\n  color: var(--sp-color-text-base);\n  font-family: 'Inter', sans-serif;\n}\n\n.workspace-settings-page .workspace-settings-content {\n  padding: 1rem;\n}\n\n.settings-layout .sidemenu-wrapper .organization-wrapper {\n  height: 60px;\n}\n\n.settings-layout .sidemenu-wrapper .organization-wrapper .organization-name {\n  font-family: 'Inter', sans-serif;\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.sidebar-main-menu {\n  border-bottom: 1px solid var(--sp-color-badge-bg-primary);\n}\n\n.sidebar-main-menu .sidebar-menu-item,\n.sidebar-menu .sidebar-menu-item {\n  color: var(--primary-icon-color);\n  border-radius: 4px;\n  background-color: transparent;\n  padding: 1rem 1rem;\n}\n\n.sidebar-main-menu .sidebar-menu-item p,\n.sidebar-menu .sidebar-menu-item p {\n  margin: 0;\n}\n\n.sidebar-menu .sidebar-menu-header h1 {\n  font-family: 'Inter', sans-serif;\n  color: var(--sp-color-text-inverted);\n  font-size: 20px;\n  font-weight: 600;\n  padding: 0.5rem 1rem;\n}\n\n.workspace-modal .checkbox-wrapper {\n  margin-top: 16px;\n}\n\n.workspace-modal .checkbox-wrapper label span:last-child {\n  display: inline-block;\n  font-family: 'Inter', sans-serif;\n  color: var(--sp-color-text-menu-default);\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.rename-template .rename-template-header {\n  padding-right: 3rem;\n}\n\n.bitbucket-import-template .bitbucket-import-template-content {\n  min-height: 320px;\n}\n\n.upload-toolbar-modal .upload-toolbar-header {\n  padding-bottom: 0;\n}\n\n.rename-template .rename-input-group {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 1rem;\n}\n\n.onedoc-modal .note,\n.onedoc-modal .input-note {\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  color: var(--sp-color-text-primary);\n\n  padding: 8px;\n  border-radius: 4px;\n  margin-top: 8px;\n}\n\n.external_link-wrapper a {\n  display: inline-block;\n  color: var(--sp-color-text-primary) !important;\n  font-family: 'Inter', sans-serif;\n  font-weight: 600;\n}\n\n.external_link-wrapper .anticon svg {\n  fill: var(--sp-color-text-primary) !important;\n}\n\n.access-form-wrapper .checkbox-wrapper label {\n  font-family: 'Inter', sans-serif;\n  font-size: 0.95rem;\n}\n\n.manage-permission-wrapper {\n  border: 1px solid var(--sp-color-action-bg-nested-hover);\n  padding: 2rem 1rem;\n  border-radius: 0.25rem;\n  height: calc(100vh - 60px);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.manage_permission_settings {\n  max-width: 550px;\n  padding: 1rem;\n}\n\n.manage_permission_settings .setting-item-header {\n  margin-bottom: 1rem;\n}\n\n.manage_permission_settings .setting-item-header .setting-item-header-content.main {\n  margin-bottom: 0.5rem;\n  color: var(--editor-heading-font-color);\n}\n\n.published-btn.success {\n  background-color: rgba(0, 255, 0, 0.1) !important;\n  color: #0d4f10 !important;\n  border-color: rgba(0, 255, 0, 0.1) !important;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.iconinput-wrapper .anticon svg {\n  fill: black !important;\n}\n\n.or-divider {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.or-divider .line {\n  display: inline-block;\n  width: 100%;\n  height: 1px;\n  background-color: var(--sp-color-text-menu-dark-default);\n}\n\n.or-divider .text {\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n}\n.icons-selector {\n  width: 220px !important;\n  height: 180px !important;\n}\n\n.icons-selector .rc-virtual-list .rc-virtual-list-holder {\n  height: 180px !important;\n}\n\n.icons-selector .rc-virtual-list-holder-inner {\n  display: grid !important;\n  grid-template-columns: repeat(4, 1fr) !important;\n  gap: 10px !important;\n  padding: 10px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.group-menu .group-menu-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 1rem;\n}\n\n.group-menu .group-menu-header h1 {\n  font-family: 'Inter', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: #fff !important;\n}\n\n.sidemenu-wrapper,\n.sidemenu-wrapper-collapsed {\n  transition: width 0.3s ease;\n}\n\n.sidemenu-wrapper-collapsed {\n  width: 5%;\n}\n\n.content-wrapper {\n  transition: width 0.3s ease;\n}\n\n.ant-menu-inline-collapsed.sidebar-menu-items {\n  width: unset !important;\n  margin-left: 11px;\n}\n\n.space-breadcumb {\n  flex-grow: 1;\n}\n\n.external_link-wrapper a {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.workspace-scroller {\n  /* height: 100%; */\n  /* max-height: 75vh; */\n  overflow-x: hidden;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.custom-btn:hover {\n  border: none !important;\n}\n\n.space-sub-header-actions .editor-save-status {\n  font-size: 14px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.25rem;\n}\n\n.rotate {\n  animation: rotateAnimation 2s linear infinite;\n}\n\n.ant-tree .ant-tree-treenode .icon {\n  width: 18px;\n  height: 18px;\n  /* other styles if needed */\n}\n\n#verificationCode,\n#phoneNumber {\n  max-width: none;\n}\n@keyframes rotateAnimation {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(-360deg);\n  }\n}\n\n/* workspace css */\n.sidebar-menu-items .ant-menu-item {\n  padding: 0.125rem 0.5rem !important;\n  border-radius: 4px !important;\n  margin: 0;\n}\n\n.sidebar-menu-items .ant-menu-item:hover .option-button {\n  display: flex !important;\n  opacity: 1 !important;\n}\n\n.sidebar-menu-items .ant-menu-title-content span {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.sidebar-menu-items .ant-menu-title-content .menu-list-wrapper {\n  margin-left: 0.75rem;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  flex: 1;\n}\n\n.sidemenu-wrapper-collapsed .ant-menu-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin: 0 5px;\n  width: 100%;\n  max-width: 60px;\n  padding: 0px !important;\n  border: none;\n  outline: none;\n}\n\n.sidemenu-wrapper-collapsed .ant-menu-item .ant-menu-title-content {\n  width: 0px !important;\n  height: 0px !important;\n}\n\n.tree-wrapper .ant-tree-treenode .ant-tree-title .text-content {\n  flex: 1;\n  word-break: break-all;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  /* max-width: 190px; */\n}\n\n.icon-selector-button:hover {\n  background-color: var(--emoji-hover-color) !important;\n}\n\n.tab-setting-item .setting-item-feedback {\n  display: inline-block;\n  padding: 0.25rem 1rem;\n  margin-top: 0.5rem;\n  border-radius: 4px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.setting-item-feedback-error {\n  color: red;\n  margin-top: 4px;\n}\n\n.setting-item-feedback-success {\n  color: green;\n  margin-top: 4px;\n}\n.user-settings-title {\n  margin: 0;\n  padding-left: 10px;\n  color: var(--primary-color);\n  font-size: 18px;\n}\n\n.settings-arrow {\n  font-size: 24px;\n  color: var(--primary-color);\n  padding-bottom: 10px !important;\n}\n\n.space-non-title {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 1rem;\n}\n.ant-select-selector {\n  background-color: var(--box-background-color);\n}\n\n.swagger-ui .renderedMarkdown p,\n.swagger-ui .renderedMarkdown ul,\n.swagger-ui .renderedMarkdown li {\n  color: var(--editor-heading-font-color);\n}\n\n.swagger-ui .scheme-container {\n  color: var(--editor-heading-font-color);\n  background-color: var(--sidemenu-background-color);\n  overflow-x: auto;\n}\n.settings-sider {\n  background: var(--sidemenu-background-color) !important;\n}\n.settings-menu {\n  background-color: var(--sidemenu-background-color) !important;\n}\n\n.login-text .ant-form-item-required {\n  color: #000000 !important;\n}\n\n.swagger-ui .opblock .opblock-summary-description {\n  color: var(--editor-text-font-color);\n}\n.swagger-ui .opblock .opblock-summary-path {\n  color: var(--editor-heading-font-color);\n}\n.swagger-ui .info .title {\n  color: var(--primary-color);\n}\n.ͼ2 .cm-gutters {\n  background-color: var(--sidemenu-background-color);\n}\n.swagger-ui .opblock-tag {\n  color: var(--editor-heading-font-color);\n}\n\n.jsonEditor .ͼe {\n  color: var(--editor-text-font-color);\n}\n.swagger-ui .expand-methods svg,\n.swagger-ui .expand-operation svg,\n.swagger-ui svg:not(:root) {\n  fill: var(--editor-heading-font-color);\n}\n\n.swagger-ui td,\n.swagger-ui h4,\n.swagger-ui h5,\n.swagger-ui .opblock-description-wrapper p,\n.btn.try-out__btn {\n  color: var(--editor-heading-font-color) !important;\n}\n\n.swagger-ui .opblock .opblock-section-header {\n  background: var(--box-background-color);\n}\n\n.btn.btn-clear.opblock-control__btn {\n  color: var(--editor-heading-font-color);\n}\n.star-icon-filled {\n  color: #ffab00;\n}\n\n/* leftbar-slider */\n.leftbar {\n  position: relative;\n}\n.leftbar:hover {\n  border-right: 1px solid var(--primary-color, #1890ff) !important;\n}\n.leftbar-slider {\n  position: absolute;\n  right: -12px;\n  top: 100px;\n  transition: all 0.3s ease;\n  border: 1px solid var(--border-color, #d9d9d9);\n  width: 24px !important;\n  height: 24px !important;\n  min-width: unset !important;\n}\n.leftbar:hover .leftbar-slider {\n  border-color: var(--primary-color, #1890ff) !important;\n  color: var(--primary-color, #1890ff) !important;\n}\n.sidemenu-wrapper-collapsed > .sidebar-menu-items {\n  margin-top: 30px;\n}\n.space-sidebar-menu-wrapper .ant-tree-treenode {\n  overflow: hidden;\n}\n.ant-switch-inner {\n  background-color: #d9d9d9;\n}\n\nbutton > span.ant-btn-icon {\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n/* For the Switch track when ON */\n.ant-switch-checked .ant-switch-inner {\n  background-color: var(--primary-color, #1890ff) !important;\n}\n\n.ai-feedbacks .ant-table-wrapper .ant-table-pagination {\n  display: flex;\n  justify-content: center;\n}\n\n.ant-divider-horizontal {\n  margin: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
